<template>
  <div>
    <v-container fluid>
      <v-toolbar dark class="header-title">
        <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('dashboardScore') }}</v-toolbar-title>
        
      </v-toolbar>
      <v-card class="card2" style="margin-top: 1rem">
        <v-flex class="flex">
          <v-row class="toolbar-row mb-3" align="center" no-gutters>
            <!-- Left group: actions -->
            <div class="toolbar-group">
              <v-btn
                v-if="isViewingHistoricalRun"
                icon
                variant="tonal"
                color="purple"
                size="small"
                class="back-to-latest-btn"
                @click="goBackToCurrentRun"
              >
                <v-icon size="20">mdi-arrow-left</v-icon>
                <v-tooltip activator="parent" location="top">
                  Back to Latest Run
                </v-tooltip>
              </v-btn>

              <v-btn
                v-if="!isViewOnly"
                id="button-reprocess-dashboardscore"
                :loading="loadingbtn"
                variant="tonal"
                color="purple"
                class="reprocess-btn"
                @click="OpenDialogReprocess()"
                prepend-icon="mdi-refresh"
                height="40"
              >
                REPROCESS
              </v-btn>

              <v-select
                v-if="viewModeOptions.length > 1"
                label="View Mode"
                :items="viewModeOptions"
                item-title="text"
                item-value="value"
                variant="outlined"
                density="compact"
                color="primary"
                v-model="viewMode"
                hide-details="auto"
                class="modern-field"
                style="min-width: 180px; max-width: 240px"
                @update:modelValue="onViewModeChange"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="primary" size="small">mdi-eye-outline</v-icon>
                </template>
              </v-select>
            </div>

            <v-spacer />

            <!-- Right group: select & search -->
            <div class="toolbar-group">
              <v-btn
                v-if="historyRuns.length > 0"
                variant="tonal"
                color="indigo"
                height="40"
                class="history-btn"
                @click="dialogHistory = true"
                prepend-icon="mdi-history"
              >
                Run History
                <template v-slot:append>
                  <v-badge
                    :content="historyRuns.length"
                    color="indigo"
                    inline
                  />
                </template>
              </v-btn>

              <v-autocomplete
                id="validationprocess-autocomplete-dashboardscore"
                label="Validation process"
                :items="DDValidationProcess"
                item-title="name"
                item-value="id"
                clearable
                variant="outlined"
                density="compact"
                color="primary"
                v-model="ProcessID"
                hide-details="auto"
                class="modern-field"
                style="min-width: 220px; max-width: 300px"
                ref="auto"
              >
                <template v-slot:prepend-inner>
                  <v-icon color="primary" size="small">mdi-cog-outline</v-icon>
                </template>
                <template v-slot:append-inner>
                  <v-tooltip location="top" max-width="300px">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        v-bind="props"
                        color="grey-darken-1"
                        size="small"
                      >
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>Select validation process to view dashboard score</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>

              <v-btn
                id="button-search-dashboardscore"
                icon
                variant="tonal"
                color="primary"
                size="small"
                class="search-btn"
                @click="SearchData"
                :disabled="!ProcessID"
              >
                <v-icon size="20">mdi-magnify</v-icon>
                <v-tooltip activator="parent" location="top">
                  {{ $t('search') }}
                </v-tooltip>
              </v-btn>
            </div>
          </v-row>
          <!-- ============================================================
               COMBINED MODE: Both Normal Score + RAGAS active
               ============================================================ -->
          <!-- Charts row — side by side -->
          <v-row v-if="isScoreMode && isRagasMode" style="margin: 1em 0">
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-2" style="height: 360px; overflow: hidden;">
                <highcharts v-if="isChartOptions" :options="chartOptions"></highcharts>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-2" style="height: 360px; overflow: hidden;">
                <highcharts v-if="isRagasChartOptions" :options="ragasChartOptions"></highcharts>
              </v-card>
            </v-col>
          </v-row>
          <!-- Model info strip — directly under charts in combined mode -->
          <v-row v-if="isScoreMode && isRagasMode" style="margin: 0 0 0.5em 0">
            <v-col cols="12">
              <div style="display: flex; gap: 16px; padding: 8px 16px; background: #e3f2fd; border-radius: 8px; font-size: 13px; color: #4c4c4c; font-weight: 600; justify-content: space-between; align-items: center;">
                <div style="display: flex; gap: 16px; align-items: center;">
                  <span>Model Name : {{ ModelName }}</span>
                  <span>Versioning : {{ Version }}</span>
                  <span>Processing Date : {{ processDate }}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="font-size: 13px; white-space: nowrap;">Show all text</span>
                  <v-switch
                    v-model="showAllText"
                    color="primary"
                    density="compact"
                    hide-details
                    inset
                    class="show-all-text-switch"
                  ></v-switch>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- Summary cards row — side by side -->
          <v-row v-if="isScoreMode && isRagasMode" style="margin: 0 0 0.5em 0">
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-1 d-flex align-center" style="height: auto; min-height: auto; padding: 0.8em 1em;">
                <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="currentColor"
                  class="bi bi-bar-chart-line-fill" viewBox="0 0 16 16" style="color: #1976d2; flex-shrink: 0;">
                  <path
                    d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z" />
                </svg>
                <label style="color: #4c4c4c; padding-left: 0.8em; font-weight: 700; font-size: 16px">
                  {{ $t('averageScore') }}
                  <br /><span id="averagescore" style="color: #8e8e8e; font-size: 32px;">{{ averageScore }} {{ $t('score') }}</span>
                </label>
              </v-card>
              <v-btn variant="text" size="small" class="mt-1" @click="showScoreDetails = !showScoreDetails">
                {{ showScoreDetails ? 'Hide details' : 'Show details' }}
                <v-icon size="small" class="ml-1">{{ showScoreDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
              <v-expand-transition>
                <div v-show="showScoreDetails">
                  <v-card class="card-1 d-flex align-center mt-2" style="height: auto; min-height: auto; padding: 0.8em 1em;">
                    <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 13px">
                      {{ $t('conditionScore0') }}<br />
                      {{ $t('conditionScore1') }}<br />
                      {{ $t('conditionScore2') }}
                    </label>
                  </v-card>
                </div>
              </v-expand-transition>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-1" style="height: auto; min-height: auto; padding: 0.6em 1em;">
                <div style="display: flex; gap: 12px;">
                  <div style="flex: 1; background: #e3f2fd; border-radius: 8px; padding: 10px 12px;">
                    <label style="font-size: 14px; color: #4c4c4c; margin-bottom: 6px; display: block; font-weight: 800;">RAGAS Average Scores</label>
                    <div v-for="metric in ragasMetricList" :key="metric.key" class="ragas-score-line">
                      <span class="legend-dot" :style="'background: ' + ragasMetricColors[metric.key]"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">{{ metric.label }}:</span>
                      <span :style="'font-size: 13px; font-weight: 800; color: ' + ragasMetricColors[metric.key] + '; margin-left: 4px;'">{{ ragasScores[metric.key].toFixed(4) }}</span>
                    </div>
                  </div>
                  <div style="flex: 1; background: #e8f5e9; border-radius: 8px; padding: 10px 12px;">
                    <label style="font-size: 14px; color: #4c4c4c; margin-bottom: 6px; display: block; font-weight: 800;">Score Rating</label>
                    <div class="ragas-score-line">
                      <span class="legend-dot" style="background: #43a047;"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">> 0.90 :</span>
                      <span style="font-size: 13px; font-weight: 800; color: #43a047; margin-left: 4px;">High</span>
                    </div>
                    <div class="ragas-score-line">
                      <span class="legend-dot" style="background: #f9a825;"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">0.60 - 0.89 :</span>
                      <span style="font-size: 13px; font-weight: 800; color: #f9a825; margin-left: 4px;">Medium</span>
                    </div>
                    <div class="ragas-score-line">
                      <span class="legend-dot" style="background: #e53935;"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">< 0.60 :</span>
                      <span style="font-size: 13px; font-weight: 800; color: #e53935; margin-left: 4px;">Low</span>
                    </div>
                  </div>
                </div>
              </v-card>
              <v-btn variant="text" size="small" class="mt-1" @click="showRagasDetails = !showRagasDetails">
                {{ showRagasDetails ? 'Hide details' : 'Show details' }}
                <v-icon size="small" class="ml-1">{{ showRagasDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
              <v-expand-transition>
                <div v-show="showRagasDetails">
                  <v-card class="card-1 mt-2" style="height: auto; min-height: auto; padding: 0.8em 1em;">
                    <div style="font-weight: 700; font-size: 13px; width: 100%;">
                      <label style="font-size: 14px; color: #4c4c4c; margin-bottom: 6px; display: block; font-weight: 800;">RAGAS Scoring Description</label>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.faithfulness">Faithfulness:</strong> Are facts in the answer supported by context? <span style="color: #6c757d;">(claims backed by context / all claims in answer)</span>
                      </div>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.answerRelevancy">Answer Relevancy:</strong> Does the answer match the question? <span style="color: #6c757d;">(similarity score)</span>
                      </div>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.contextPrecision">Context Precision:</strong> Are useful contexts ranked first? <span style="color: #6c757d;">(Precision@K)</span>
                      </div>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.contextRecall">Context Recall:</strong> Is the correct answer covered by context? <span style="color: #6c757d;">(ground-truth statements found in context / all ground-truth statements)</span>
                      </div>
                      <div class="ragas-metric-item" style="margin-top: 4px;">
                        <span style="color: #6c757d;font-weight: 800;">All scores range from <strong>0.0</strong> (worst) to <strong>1.0</strong> (best).</span>
                      </div>
                      <div v-if="isChainProcess" class="ragas-metric-item" style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e0e0e0;">
                        <strong style="color: #7b1fa2;">Conversation Verdict:</strong> Did the bot handle the full conversation correctly? <span style="color: #6c757d;">Remembers earlier messages · Completes all requests · Gives consistent answers.</span>
                        <br/>
                        <strong style="color: #4caf50;">Pass:</strong> <span style="color: #6c757d;">All 3 criteria are met — the bot remembered context, completed every request, and gave consistent answers.</span>
                        <br/>
                        <strong style="color: #f44336;">Fail:</strong> <span style="color: #6c757d;">Any criterion is not met — the bot forgot context, missed a request, or contradicted itself.</span>
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-expand-transition>
            </v-col>
          </v-row>

          <!-- ============================================================
               SINGLE MODE: Only Normal Score
               ============================================================ -->
          <v-row v-if="isScoreMode && !isRagasMode" style="margin: 1em 0">
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-2" style="max-height: 350px; overflow: hidden;">
                <highcharts v-if="isChartOptions" :options="chartOptions"></highcharts>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-1 d-flex align-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="currentColor"
                  class="bi bi-bar-chart-line-fill" viewBox="0 0 16 16" style="margin-left: 1em; color: #1976d2">
                  <path
                    d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z" />
                </svg>
                <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 18px">
                  {{ $t('averageScore') }}
                  <br /><span id="averagescore" style="color: #8e8e8e; font-size: 40px">{{ averageScore }} {{ $t('score') }}</span>
                </label>
              </v-card>
              <v-btn variant="text" size="small" class="mb-2" @click="showScoreDetails = !showScoreDetails">
                {{ showScoreDetails ? 'Hide details' : 'Show details' }}
                <v-icon size="small" class="ml-1">{{ showScoreDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
              <v-expand-transition>
                <div v-show="showScoreDetails">
                  <v-card class="card-1 d-flex align-center mb-6">
                    <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 14px">
                      {{ $t('conditionScore0') }}<br />
                      {{ $t('conditionScore1') }}<br />
                      {{ $t('conditionScore2') }}
                    </label>
                  </v-card>
                </div>
              </v-expand-transition>
            </v-col>
          </v-row>
          <!-- Model info strip — Normal-only mode -->
          <v-row v-if="isScoreMode && !isRagasMode" style="margin: 0 0 0.5em 0">
            <v-col cols="12">
              <div style="display: flex; gap: 16px; padding: 8px 16px; background: #e3f2fd; border-radius: 8px; font-size: 13px; color: #4c4c4c; font-weight: 600; justify-content: space-between; align-items: center;">
                <div style="display: flex; gap: 16px; align-items: center;">
                  <span>Model Name : {{ ModelName }}</span>
                  <span>Versioning : {{ Version }}</span>
                  <span>Processing Date : {{ processDate }}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="font-size: 13px; white-space: nowrap;">Show all text</span>
                  <v-switch
                    v-model="showAllText"
                    color="primary"
                    density="compact"
                    hide-details
                    inset
                    class="show-all-text-switch"
                  ></v-switch>
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- ============================================================
               SINGLE MODE: Only RAGAS
               ============================================================ -->
          <v-row v-if="isRagasMode && !isScoreMode" style="margin: 1em 0">
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-2" style="height: 400px; overflow: hidden;">
                <highcharts v-if="isRagasChartOptions" :options="ragasChartOptions"></highcharts>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-1 mb-4" style="height: auto; min-height: auto; padding: 0.6em 1em;">
                <div style="display: flex; gap: 12px;">
                  <div style="flex: 1; background: #e3f2fd; border-radius: 8px; padding: 10px 12px;">
                    <label style="font-size: 15px; color: #4c4c4c; margin-bottom: 6px; display: block; font-weight: 800;">Average Scores</label>
                    <div v-for="metric in ragasMetricList" :key="metric.key" class="ragas-score-line">
                      <span class="legend-dot" :style="'background: ' + ragasMetricColors[metric.key]"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">{{ metric.label }}:</span>
                      <span :style="'font-size: 13px; font-weight: 800; color: ' + ragasMetricColors[metric.key] + '; margin-left: 4px;'">{{ ragasScores[metric.key].toFixed(4) }}</span>
                    </div>
                  </div>
                  <div style="flex: 1; background: #e8f5e9; border-radius: 8px; padding: 10px 12px;">
                    <label style="font-size: 15px; color: #4c4c4c; margin-bottom: 6px; display: block; font-weight: 800;">Score Rating</label>
                    <div class="ragas-score-line">
                      <span class="legend-dot" style="background: #43a047;"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">> 0.90 :</span>
                      <span style="font-size: 13px; font-weight: 800; color: #43a047; margin-left: 4px;">High</span>
                    </div>
                    <div class="ragas-score-line">
                      <span class="legend-dot" style="background: #f9a825;"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">0.60 - 0.89 :</span>
                      <span style="font-size: 13px; font-weight: 800; color: #f9a825; margin-left: 4px;">Medium</span>
                    </div>
                    <div class="ragas-score-line">
                      <span class="legend-dot" style="background: #e53935;"></span>
                      <span style="font-size: 13px; font-weight: 600; color: #4c4c4c;">< 0.60 :</span>
                      <span style="font-size: 13px; font-weight: 800; color: #e53935; margin-left: 4px;">Low</span>
                    </div>
                  </div>
                </div>
              </v-card>
              <v-btn variant="text" size="small" class="mb-2" @click="showRagasDetails = !showRagasDetails">
                {{ showRagasDetails ? 'Hide details' : 'Show details' }}
                <v-icon size="small" class="ml-1">{{ showRagasDetails ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
              <v-expand-transition>
                <div v-show="showRagasDetails">
                  <v-card class="card-1 d-flex align-center" style="height: auto; min-height: 125px; padding: 1em;">
                    <div style="padding-left: 1em; font-weight: 700; font-size: 14px; width: 100%;">
                      <label style="font-size: 15px; color: #4c4c4c; margin-bottom: 8px; display: block; font-weight: 800;">RAGAS Scoring Description</label>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.faithfulness">Faithfulness:</strong> Are facts in the answer supported by context? <span style="color: #6c757d;">(claims backed by context / all claims in answer)</span>
                      </div>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.answerRelevancy">Answer Relevancy:</strong> Does the answer match the question? <span style="color: #6c757d;">(similarity score)</span>
                      </div>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.contextPrecision">Context Precision:</strong> Are useful contexts ranked first? <span style="color: #6c757d;">(Precision@K)</span>
                      </div>
                      <div class="ragas-metric-item">
                        <strong :style="'color: ' + ragasMetricColors.contextRecall">Context Recall:</strong> Is the correct answer covered by context? <span style="color: #6c757d;">(ground-truth statements found in context / all ground-truth statements)</span>
                      </div>
                      <div class="ragas-metric-item" style="margin-top: 6px;">
                        <span style="color: #6c757d;font-weight: 800;">All scores range from <strong>0.0</strong> (worst) to <strong>1.0</strong> (best).</span>
                      </div>
                      <div v-if="isChainProcess" class="ragas-metric-item" style="margin-top: 8px; padding-top: 8px; border-top: 1px solid #e0e0e0;">
                        <strong style="color: #7b1fa2;">Conversation Verdict:</strong> Did the bot handle the full conversation correctly? <span style="color: #6c757d;">Remembers earlier messages · Completes all requests · Gives consistent answers.</span>
                        <br/>
                        <strong style="color: #4caf50;">Pass:</strong> <span style="color: #6c757d;">All 3 criteria are met — the bot remembered context, completed every request, and gave consistent answers.</span>
                        <br/>
                        <strong style="color: #f44336;">Fail:</strong> <span style="color: #6c757d;">Any criterion is not met — the bot forgot context, missed a request, or contradicted itself.</span>
                      </div>
                    </div>
                  </v-card>
                </div>
              </v-expand-transition>
            </v-col>
          </v-row>
          <!-- Model info strip — RAGAS-only mode -->
          <v-row v-if="isRagasMode && !isScoreMode" style="margin: 0 0 0.5em 0">
            <v-col cols="12">
              <div style="display: flex; gap: 16px; padding: 8px 16px; background: #e3f2fd; border-radius: 8px; font-size: 13px; color: #4c4c4c; font-weight: 600; justify-content: space-between; align-items: center;">
                <div style="display: flex; gap: 16px; align-items: center;">
                  <span>Model Name : {{ ModelName }}</span>
                  <span>Versioning : {{ Version }}</span>
                  <span>Processing Date : {{ processDate }}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="font-size: 13px; white-space: nowrap;">Show all text</span>
                  <v-switch
                    v-model="showAllText"
                    color="primary"
                    density="compact"
                    hide-details
                    inset
                    class="show-all-text-switch"
                  ></v-switch>
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- ============================================================
               ANSWER ONLY MODE: No scoring, no RAGAS
               ============================================================ -->
          <v-row v-if="!isScoreMode && !isRagasMode" style="margin: 1em 0">
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-2" style="max-height: 350px; overflow: hidden;">
                <highcharts v-if="isChartOptions" :options="chartOptions"></highcharts>
              </v-card>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-card class="card-1 d-flex align-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" fill="currentColor"
                  class="bi bi-bar-chart-line-fill" viewBox="0 0 16 16" style="margin-left: 1em; color: #1976d2">
                  <path
                    d="M11 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12h.5a.5.5 0 0 1 0 1H.5a.5.5 0 0 1 0-1H1v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h1V7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7h1V2z" />
                </svg>
                <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 18px">
                  {{ $t('averageScore') }}
                  <br /><span style="color: #8e8e8e; font-size: 40px">{{ averageScore }} {{ $t('score') }}</span>
                </label>
              </v-card>
              <v-card class="card-1 d-flex align-center mb-6">
                <label style="color: #4c4c4c; padding-left: 1em; font-weight: 700; font-size: 14px">
                  {{ $t('conditionScore0') }}<br />
                  {{ $t('conditionScore1') }}<br />
                  {{ $t('conditionScore2') }}
                </label>
              </v-card>
            </v-col>
          </v-row>
          <!-- Model info strip — Answer Only mode -->
          <v-row v-if="!isScoreMode && !isRagasMode" style="margin: 0 0 0.5em 0">
            <v-col cols="12">
              <div style="display: flex; gap: 16px; padding: 8px 16px; background: #e3f2fd; border-radius: 8px; font-size: 13px; color: #4c4c4c; font-weight: 600; justify-content: space-between; align-items: center;">
                <div style="display: flex; gap: 16px; align-items: center;">
                  <span>Model Name : {{ ModelName }}</span>
                  <span>Versioning : {{ Version }}</span>
                  <span>Processing Date : {{ processDate }}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 8px;">
                  <span style="font-size: 13px; white-space: nowrap;">Show all text</span>
                  <v-switch
                    v-model="showAllText"
                    color="primary"
                    density="compact"
                    hide-details
                    inset
                    class="show-all-text-switch"
                  ></v-switch>
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row style="margin: 1em 0">
            <v-col cols="12" sm="12" md="12">
              <v-data-table-server class="modern-table" :items-per-page="options.itemsPerPage" :items-length="searchTotalTable" v-model:options="options"
                :items="dataTable" :headers="headers">
                <template v-slot:item="{ item }">
                  <tr>
                    <td style="text-align: left; width: 50px; min-width: 50px;">{{ item.number }}</td>
                    <td style="text-align: left; width: 250px; min-width: 250px;" class="text-cell">
                      <div class="cell-content">
                        {{ isExpanded(item.number, 'question') ? item.question : truncateText(item.question, 150) }}
                        <span v-if="item.question && item.question.length > 150"
                              class="toggle-text"
                              @click="toggleCell(item.number, 'question')">
                          {{ isExpanded(item.number, 'question') ? 'See less' : 'See more' }}
                        </span>
                      </div>
                    </td>
                    <td style="text-align: left; width: 350px; min-width: 350px;" class="text-cell">
                      <div class="cell-content">
                        <template v-if="item.status && item.status.startsWith('error') && item.status !== 'error:score'">-</template>
                        <template v-else>
                          {{ isExpanded(item.number, 'answer') ? item.answer : truncateText(item.answer, 150) }}
                          <span v-if="item.answer && item.answer.length > 150"
                                class="toggle-text"
                                @click="toggleCell(item.number, 'answer')">
                            {{ isExpanded(item.number, 'answer') ? 'See less' : 'See more' }}
                          </span>
                        </template>
                      </div>
                    </td>
                    <td style="text-align: left; width: 350px; min-width: 350px;" class="text-cell">
                      <div class="cell-content">
                        {{ isExpanded(item.number, 'humanAnswer') ? item.humanAnswer : truncateText(item.humanAnswer, 150) }}
                        <span v-if="item.humanAnswer && item.humanAnswer.length > 150"
                              class="toggle-text"
                              @click="toggleCell(item.number, 'humanAnswer')">
                          {{ isExpanded(item.number, 'humanAnswer') ? 'See less' : 'See more' }}
                        </span>
                      </div>
                    </td>
                    <td v-if="isScoreMode" style="text-align: left; width: 80px; min-width: 80px;">{{ item.score ?? '-' }}</td>
                    <td v-if="isScoreMode" style="text-align: left; width: 450px; min-width: 450px;" class="text-cell">
                      <div class="cell-content">
                        <template v-if="isExpanded(item.number, 'reason')">{{ item.scoreReason }}</template>
                        <template v-else>{{ truncateText(item.scoreReason, 80) }}</template>
                        <span v-if="item.scoreReason && item.scoreReason.length > 80"
                              class="toggle-text"
                              @click="toggleCell(item.number, 'reason')">
                          {{ isExpanded(item.number, 'reason') ? 'See less' : 'See more' }}
                        </span>
                        <span v-if="!item.scoreReason">-</span>
                      </div>
                    </td>
                    <td v-if="isRagasMode" style="text-align: center; width: 110px; min-width: 110px;">{{ item.ragasFaithfulness != null ? parseFloat(item.ragasFaithfulness).toFixed(4) : '-' }}</td>
                    <td v-if="isRagasMode" style="text-align: center; width: 110px; min-width: 110px;">{{ item.ragasAnswerRelevancy != null ? parseFloat(item.ragasAnswerRelevancy).toFixed(4) : '-' }}</td>
                    <td v-if="isRagasMode" style="text-align: center; width: 110px; min-width: 110px;">{{ item.ragasContextPrecision != null ? parseFloat(item.ragasContextPrecision).toFixed(4) : '-' }}</td>
                    <td v-if="isRagasMode" style="text-align: center; width: 110px; min-width: 110px;">{{ item.ragasContextRecall != null ? parseFloat(item.ragasContextRecall).toFixed(4) : '-' }}</td>
                    <td v-if="isRagasMode" class="text-cell" style="width: 500px; min-width: 500px;">
                      <div class="cell-content">
                        <template v-if="item.ragasAspectCriticReason">
                          <div v-if="isExpanded(item.number, 'ragasReason')">
                            <div><strong>Group Verdict:</strong> {{ item.ragasAspectCriticReason }}</div>
                          </div>
                          <div v-else>
                            {{ truncateText(item.ragasAspectCriticReason, 80) }}
                          </div>
                          <span class="toggle-text" @click="toggleCell(item.number, 'ragasReason')">
                            {{ isExpanded(item.number, 'ragasReason') ? 'See less' : 'See more' }}
                          </span>
                        </template>
                        <template v-else-if="hasAnyRagasReason(item)">
                          <div v-if="isExpanded(item.number, 'ragasReason')">
                            <div><strong>Faithfulness:</strong> {{ item.ragasFaithfulnessReason || '-' }}</div>
                            <div><strong>Answer Relevancy:</strong> {{ item.ragasAnswerRelevancyReason || '-' }}</div>
                            <div><strong>Context Precision:</strong> {{ item.ragasContextPrecisionReason || '-' }}</div>
                            <div><strong>Context Recall:</strong> {{ item.ragasContextRecallReason || '-' }}</div>
                          </div>
                          <div v-else>
                            {{ truncateText(getFirstRagasReason(item), 80) }}
                          </div>
                          <span class="toggle-text" @click="toggleCell(item.number, 'ragasReason')">
                            {{ isExpanded(item.number, 'ragasReason') ? 'See less' : 'See more' }}
                          </span>
                        </template>
                        <span v-else-if="item.ragasErrorMessage" style="color: #e53935; font-style: italic;">
                          {{ item.ragasErrorMessage }}
                        </span>
                        <span v-else>-</span>
                      </div>
                    </td>
                    <td style="text-align: left; width: 300px; min-width: 300px;" class="text-cell">
                      <div class="cell-content" style="font-size: 0.82rem;">
                        <template v-if="formatWorkflow(item.chatWorkFlow)">
                          {{ isExpanded(item.number, 'chatWorkFlow')
                               ? formatWorkflow(item.chatWorkFlow)
                               : truncateText(formatWorkflow(item.chatWorkFlow), 80) }}
                          <span v-if="formatWorkflow(item.chatWorkFlow).length > 80"
                                class="toggle-text"
                                @click="toggleCell(item.number, 'chatWorkFlow')">
                            {{ isExpanded(item.number, 'chatWorkFlow') ? 'See less' : 'See more' }}
                          </span>
                        </template>
                        <span v-else>-</span>
                      </div>
                    </td>
                    <td style="text-align: center; width: 90px; min-width: 90px;">
                      <template v-if="item.question && item.question.trim() === '#End#' && isRagasMode">
                        <span class="status-dot" :class="item.ragasOverallScore === 1 ? 'status-dot--success' : 'status-dot--error'">
                          {{ item.ragasOverallScore === 1 ? 'Pass' : 'Fail' }}
                        </span>
                      </template>
                      <template v-else-if="item.question && item.question.trim() === '#End#' && !isRagasMode">
                        <span>-</span>
                      </template>
                      <template v-else>
                        <span class="status-dot" :class="item.status && item.status.startsWith('error') ? 'status-dot--error' : 'status-dot--success'">
                          {{ item.status && item.status.startsWith('error') ? 'Fail' : 'Success' }}
                        </span>
                      </template>
                    </td>
                    <td style="text-align: center; width: 120px; min-width: 120px;">
                      <v-btn
                        v-if="(item.chatWorkFlow && item.chatWorkFlow !== '-') || (isRagasMode && item.question && item.question.trim() === '#End#' && item.ragasRawDetail)"
                        icon
                        size="small"
                        variant="text"
                        :color="item.question && item.question.trim() === '#End#' ? 'deep-purple' : 'primary'"
                        @click="openContextDialog(item)"
                        :title="item.question && item.question.trim() === '#End#' ? 'View Group Verdict Detail' : 'View Retrieved Documents'"
                      >
                        <v-icon>{{ item.question && item.question.trim() === '#End#' ? 'mdi-clipboard-check-outline' : 'mdi-file-document-outline' }}</v-icon>
                      </v-btn>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </template>
              </v-data-table-server>
            </v-col>
          </v-row>

          <!-- Run History dialog is rendered below, outside the card -->
        </v-flex>
      </v-card>
    </v-container>


    <v-dialog v-model="dialogHistory" max-width="560px" content-class="history-dialog-wrapper">
      <div class="history-dialog">
        <!-- Header -->
        <div class="history-dialog-header">
          <div class="history-dialog-header-left">
            <div class="history-dialog-icon-wrap">
              <v-icon size="20" color="white">mdi-history</v-icon>
            </div>
            <div>
              <div class="history-dialog-title">Run History</div>
              <div class="history-dialog-subtitle">{{ historyRuns.length }} previous {{ historyRuns.length === 1 ? 'run' : 'runs' }}</div>
            </div>
          </div>
          <button class="history-dialog-close" @click="dialogHistory = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>

        <!-- Run list -->
        <div class="history-dialog-body">
          <div
            v-for="(run, idx) in historyRuns"
            :key="run.processId"
            class="history-run-card"
            :style="{ animationDelay: (idx * 60) + 'ms' }"
          >
            <div class="history-run-card-left">
              <span class="history-run-number">#{{ historyRuns.length - idx }}</span>
              <div class="history-run-type">
                <v-icon size="14" class="mr-1" style="opacity: 0.55;">mdi-flask-outline</v-icon>
                {{ run.displayScoringType }}
              </div>
              <div class="history-run-meta">
                <span class="history-run-date">
                  <v-icon size="12" class="mr-1" style="opacity: 0.4;">mdi-calendar-outline</v-icon>
                  {{ run.date }}
                </span>
                <span
                  class="history-run-status"
                  :class="run.isActive ? 'history-run-status--active' : 'history-run-status--inactive'"
                >
                  <span class="history-status-dot"></span>
                  {{ run.isActive ? 'Active' : 'Inactive' }}
                </span>
              </div>
            </div>
            <button class="history-run-view-btn" @click="onHistoryRunSelect(run)">
              <v-icon size="15" class="mr-1">mdi-eye-outline</v-icon>
              View
            </button>
          </div>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="dialogReprocess" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('_Reprocess') }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" sm="12" md="12">
                <v-autocomplete 
                  label="Model Name" 
                  :items="DDGPTModel" 
                  item-title="name" 
                  item-value="modelDisplayID" 
                  clearable 
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  v-model="Reprocess.modelId" 
                  :rules="[rules.required]" 
                  required
                  class="modern-field"
                  hide-details="auto"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-brain</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          v-bind="props"
                          color="grey-darken-1"
                          size="small"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t('_InfoModelName') }}</span>
                    </v-tooltip> 
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <!-- <v-col cols="6" sm="6" md="6">
                <v-autocomplete 
                  label="Model Name" 
                  :items="DDGPTModel" 
                  item-title="name" 
                  item-value="modelDisplayID" 
                  clearable 
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  v-model="Reprocess.modelId" 
                  :rules="[rules.required]" 
                  required
                  class="modern-field"
                  hide-details="auto"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-brain</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip location="top" max-width="300px">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          v-bind="props"
                          color="grey-darken-1"
                          size="small"
                        >
                          mdi-information-outline
                        </v-icon>
                      </template>
                      <span>{{ $t('_InfoModelName') }}</span>
                    </v-tooltip> 
                  </template>
                </v-autocomplete>
              </v-col> -->
              <v-col cols="6" sm="6" md="6">
                <v-checkbox
                  v-model="Reprocess.isScore"
                  color="primary"
                  hide-details
                  class="modern-checkbox"
                  @change="handleReprocessScoreChange"
                >
                  <template v-slot:label>
                    <div class="checkbox-label-wrapper">
                      <v-icon size="small" color="primary" class="mr-2">mdi-calculator</v-icon>
                      <span>{{ $t('calculateScores') }}</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                            class="ml-1"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{ $t('calculateScores') }}</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="6" sm="6" md="6">
                <v-checkbox
                  v-model="Reprocess.isRagas"
                  color="primary"
                  hide-details
                  class="modern-checkbox"
                  @change="handleReprocessRagasChange"
                >
                  <template v-slot:label>
                    <div class="checkbox-label-wrapper">
                      <v-icon size="small" color="primary" class="mr-2">mdi-chart-box-outline</v-icon>
                      <span>RAGAS Score</span>
                      <v-tooltip location="top" max-width="300px">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            v-bind="props"
                            color="grey-darken-1"
                            size="small"
                            class="ml-1"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>RAGAS Score</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-show="Reprocess.isScore">
                <v-textarea 
                  label="Prompt" 
                  variant="outlined"
                  counter 
                  auto-grow 
                  rows="15" 
                  v-model="Reprocess.Prompt" 
                  required
                  color="primary"
                  class="modern-textarea"
                  hide-details="auto"
                >
                  <template v-slot:prepend-inner>
                    <v-icon color="primary" size="small">mdi-text-long</v-icon>
                  </template>
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <!-- <small>*indicates required field</small> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="CloseDialogReprocess()"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loadingbtn"
            :loading="loadingbtn"
            @click="ReProcess()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Context Detail Dialog -->
    <v-dialog v-model="dialogContext" max-width="1100px" scrollable content-class="ctx-dialog-wrapper">
      <div class="ctx-dialog">
        <!-- Header -->
        <div class="ctx-header">
          <div class="ctx-header-left">
            <div class="ctx-header-icon" :style="isEndMarkDialog ? 'background: linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)' : ''">
              <v-icon size="20" color="white">{{ isEndMarkDialog ? 'mdi-clipboard-check-outline' : 'mdi-file-document-outline' }}</v-icon>
            </div>
            <div>
              <div class="ctx-header-title">{{ isEndMarkDialog ? 'Group Verdict Detail' : 'Context Detail' }}</div>
            </div>
          </div>
          <button class="ctx-header-close" @click="dialogContext = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </div>

        <!-- Body -->
        <div class="ctx-body">
          <!-- Question & Answer summary / Group Verdict summary -->
          <div v-if="contextDialogItem && isEndMarkDialog" class="ctx-section ctx-qa-summary">
            <div class="ctx-qa-row">
              <div class="ctx-qa-label">
                <v-icon size="14" class="mr-1" style="opacity: 0.5;">mdi-check-decagram</v-icon>
                Verdict
              </div>
              <div class="ctx-qa-text">
                <span
                  class="status-dot"
                  :class="contextDialogItem.ragasOverallScore === 1 ? 'status-dot--success' : 'status-dot--error'"
                  style="font-weight: 600;"
                >
                  {{ contextDialogItem.ragasOverallScore === 1 ? 'Pass' : 'Fail' }}
                </span>
              </div>
            </div>
            <div class="ctx-qa-row">
              <div class="ctx-qa-label">
                <v-icon size="14" class="mr-1" style="opacity: 0.5;">mdi-text-box-outline</v-icon>
                Reason
              </div>
              <div class="ctx-qa-text">{{ contextDialogItem.ragasAspectCriticReason || '-' }}</div>
            </div>
          </div>
          <div v-else-if="contextDialogItem" class="ctx-section ctx-qa-summary">
            <div class="ctx-qa-row">
              <div class="ctx-qa-label">
                <v-icon size="14" class="mr-1" style="opacity: 0.5;">mdi-help-circle-outline</v-icon>
                Question
              </div>
              <div class="ctx-qa-text">{{ contextDialogItem.question || '-' }}</div>
            </div>
            <div class="ctx-qa-row">
              <div class="ctx-qa-label">
                <v-icon size="14" class="mr-1" style="opacity: 0.5;">mdi-message-reply-text-outline</v-icon>
                Answer
              </div>
              <div class="ctx-qa-text">{{ (contextDialogItem.status && contextDialogItem.status.startsWith('error') && contextDialogItem.status !== 'error:score') ? '-' : (contextDialogItem.answer || '-') }}</div>
            </div>
          </div>

          <!-- Loading -->
          <div v-if="contextLoading" class="ctx-empty-state">
            <v-progress-circular indeterminate color="#667eea" size="36" width="3"></v-progress-circular>
            <span class="ctx-empty-label">Loading document references...</span>
          </div>
          <!-- Error -->
          <div v-else-if="contextError" class="ctx-section">
            <div class="ctx-error-box">
              <v-icon size="18" color="#d32f2f" class="mr-2">mdi-alert-circle-outline</v-icon>
              {{ contextError }}
            </div>
          </div>
          <!-- Document Node View -->
          <div v-else-if="contextDocStep">
            <!-- Status & Node row -->
            <div class="ctx-section ctx-status-row">
              <span class="ctx-status-badge" :class="'ctx-status--' + (contextDocStep.status || 'unknown').toLowerCase()">
                <span class="ctx-status-dot"></span>
                {{ contextDocStep.status || 'Unknown' }}
              </span>
              <span class="ctx-node-label">
                <v-icon size="13" class="mr-1" style="opacity: 0.45;">mdi-lan</v-icon>
                Node: {{ contextDocStep.node || '-' }}
              </span>
            </div>

            <!-- Input / Output -->
            <div class="ctx-section ctx-io-grid">
              <div class="ctx-io-panel">
                <div class="ctx-io-header">
                  <span class="ctx-io-title">
                    <v-icon size="14" class="mr-1" style="opacity: 0.5;">mdi-arrow-right-bold-box-outline</v-icon>
                    Input Data
                  </span>
                  <button class="ctx-copy-btn" @click="copyContextText(contextDocStep.input && contextDocStep.input.message)" title="Copy">
                    <v-icon size="14">mdi-content-copy</v-icon>
                  </button>
                </div>
                <pre class="ctx-code-block">{{ (contextDocStep.input && contextDocStep.input.message) || '-' }}</pre>
              </div>
              <div class="ctx-io-panel">
                <div class="ctx-io-header">
                  <span class="ctx-io-title">
                    <v-icon size="14" class="mr-1" style="opacity: 0.5;">mdi-arrow-left-bold-box-outline</v-icon>
                    Output Data
                  </span>
                  <button class="ctx-copy-btn" @click="copyContextText(contextDocStep.output && contextDocStep.output.message)" title="Copy">
                    <v-icon size="14">mdi-content-copy</v-icon>
                  </button>
                </div>
                <pre class="ctx-code-block">{{ (contextDocStep.output && contextDocStep.output.message) || '-' }}</pre>
              </div>
            </div>

            <!-- Knowledge Sources -->
            <div v-if="contextKnowledgeSources" class="ctx-section">
              <div class="ctx-section-label">Knowledge Sources</div>
              <div class="ctx-knowledge-grid">
                <div v-if="contextKnowledgeSources.community" class="ctx-knowledge-card ctx-knowledge-card--community">
                  <div class="ctx-knowledge-card-icon" style="background: rgba(156, 39, 176, 0.1); color: #9c27b0;">
                    <v-icon size="16">mdi-graph-outline</v-icon>
                  </div>
                  <div class="ctx-knowledge-card-body">
                    <div class="ctx-knowledge-card-title">Community</div>
                    <div class="ctx-knowledge-card-detail">ID: {{ contextKnowledgeSources.community.communityId }} &middot; {{ contextKnowledgeSources.community.groups }} groups &middot; {{ contextKnowledgeSources.community.chunks }} chunks</div>
                  </div>
                </div>
                <div v-if="contextKnowledgeSources.documents" class="ctx-knowledge-card ctx-knowledge-card--documents">
                  <div class="ctx-knowledge-card-icon" style="background: rgba(33, 150, 243, 0.1); color: #2196f3;">
                    <v-icon size="16">mdi-database-outline</v-icon>
                  </div>
                  <div class="ctx-knowledge-card-body">
                    <div class="ctx-knowledge-card-title">Documents</div>
                    <div class="ctx-knowledge-card-detail">VectorDB: {{ contextKnowledgeSources.documents.vectorDB }} &middot; {{ contextKnowledgeSources.documents.chunks }} chunks</div>
                  </div>
                </div>
              </div>
              <div v-if="contextKnowledgeSources.mode === 'community+documents'" class="ctx-mode-badge">
                <v-icon size="13" class="mr-1">mdi-merge</v-icon>
                Combined Mode (Graph + Docs)
              </div>
              <div v-if="!contextKnowledgeSources.community && !contextKnowledgeSources.documents" class="ctx-empty-hint">
                No workflow metadata available.
              </div>
            </div>

            <!-- Top-level tabs: Retrieved Chunks / Scoring Prompts -->
            <div v-if="contextDocStepDocs.length > 0 || parsedRagasRawDetail.length > 0" class="ctx-section">
              <v-tabs v-model="contextMainTab" density="compact" color="primary" class="ctx-main-tabs">
                <v-tab value="chunks">
                  <v-icon size="15" class="mr-1">mdi-text-box-search-outline</v-icon>
                  Retrieved Chunks
                  <span v-if="contextDocStepDocs.length" class="ctx-tab-count">{{ contextDocStepDocs.length }}</span>
                </v-tab>
                <v-tab v-if="parsedRagasRawDetail.length > 0" value="scoring">
                  <v-icon size="15" class="mr-1">mdi-chart-box-outline</v-icon>
                  Scoring Prompts
                  <span class="ctx-tab-count">{{ parsedRagasRawDetail.length }}</span>
                </v-tab>
              </v-tabs>

              <v-tabs-window v-model="contextMainTab">
                <!-- Tab 1: Retrieved Chunks -->
                <v-tabs-window-item value="chunks">
                  <div v-if="contextDocStepDocs.length > 0" class="ctx-tab-content">
                    <div class="ctx-chunks-list">
                      <div v-for="(doc, idx) in contextDocStepDocs" :key="idx" class="ctx-chunk-card">
                        <div class="ctx-chunk-top">
                          <div class="ctx-chunk-badges">
                            <span class="ctx-chunk-id">{{ doc.id || '-' }}</span>
                            <span v-if="contextDocStep.node === 'community+documents'"
                              class="ctx-chunk-source"
                              :class="doc.source === 'community' ? 'ctx-chunk-source--graph' : 'ctx-chunk-source--doc'"
                            >
                              {{ doc.source === 'community' ? 'Graph' : 'Doc' }}
                            </span>
                            <span class="ctx-chunk-status"
                              :class="getDocStatusClass(doc)"
                            >
                              {{ getDocStatusLabel(doc) }}
                            </span>
                            <span v-if="doc.effectiveStartDate || doc.effectiveEndDate" class="ctx-chunk-dates"
                              :class="isDocExpired(doc) ? 'ctx-chunk-dates--expired' : ''"
                            >
                              📅 <template v-if="isDocExpired(doc)">Expired: </template>
                              <template v-if="doc.effectiveStartDate && doc.effectiveEndDate">{{ formatShortDate(doc.effectiveStartDate) }} – {{ formatShortDate(doc.effectiveEndDate) }}</template>
                              <template v-else-if="doc.effectiveStartDate">from {{ formatShortDate(doc.effectiveStartDate) }}</template>
                              <template v-else-if="doc.effectiveEndDate">until {{ formatShortDate(doc.effectiveEndDate) }}</template>
                            </span>
                          </div>
                          <div class="ctx-chunk-doc-name" @click="copyContextText(doc.documentName)" :title="(doc.documentName || '-') + ' (Click to copy)'">
                            <v-icon size="13" class="mr-1" style="opacity: 0.4;">mdi-file-outline</v-icon>
                            {{ doc.documentName || '-' }}
                          </div>
                        </div>
                        <div class="ctx-chunk-content" @click="copyContextText(doc.textORG)" :title="(doc.textORG || '-') + ' (Click to copy)'">
                          {{ doc.textORG || '-' }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="ctx-tab-content">
                    <div class="ctx-info-box">
                      <v-icon size="16" color="#1976d2" class="mr-2">mdi-information-outline</v-icon>
                      No document chunks found for this node.
                    </div>
                  </div>
                </v-tabs-window-item>

                <!-- Tab 2: Scoring Prompts (collapsible accordion) -->
                <v-tabs-window-item value="scoring">
                  <div class="ctx-tab-content">
                    <div v-for="tab in parsedRagasRawDetail" :key="tab.key" class="ctx-metric-card">
                      <div class="ctx-metric-header" @click="toggleMetricExpand(tab.key)">
                        <div class="ctx-metric-header-left">
                          <v-icon size="16" :color="expandedMetrics[tab.key] ? '#1976d2' : '#94a3b8'" class="mr-2">
                            {{ expandedMetrics[tab.key] ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                          </v-icon>
                          <span class="ctx-metric-label">{{ tab.label }}</span>
                        </div>
                        <div class="ctx-metric-header-right">
                          <v-chip size="x-small" variant="tonal" color="primary" v-if="tab.prompt">Prompt</v-chip>
                          <v-chip size="x-small" variant="tonal" color="success" v-if="tab.response">Response</v-chip>
                        </div>
                      </div>
                      <div v-show="expandedMetrics[tab.key]" class="ctx-metric-body">
                        <!-- Prompt -->
                        <div class="ctx-metric-block">
                          <div class="ctx-metric-block-header">
                            <v-icon size="14" class="mr-1" style="opacity:0.5;">mdi-arrow-right-bold-box-outline</v-icon>
                            Prompt
                            <button class="ctx-copy-btn" @click.stop="copyContextText(tab.prompt)" title="Copy">
                              <v-icon size="14">mdi-content-copy</v-icon>
                            </button>
                          </div>
                          <pre class="ctx-ragas-pre">{{ tab.prompt || 'No prompt available' }}</pre>
                        </div>
                        <!-- LLM Response -->
                        <div class="ctx-metric-block">
                          <div class="ctx-metric-block-header">
                            <v-icon size="14" class="mr-1" style="opacity:0.5;">mdi-arrow-left-bold-box-outline</v-icon>
                            LLM Response
                            <button class="ctx-copy-btn" @click.stop="copyContextText(tab.response)" title="Copy">
                              <v-icon size="14">mdi-content-copy</v-icon>
                            </button>
                          </div>
                          <pre class="ctx-ragas-pre">{{ formatJsonSafe(tab.response) }}</pre>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tabs-window-item>
              </v-tabs-window>
            </div>
            <div v-else-if="!contextLoading && contextDocStep" class="ctx-section">
              <div class="ctx-info-box">
                <v-icon size="16" color="#1976d2" class="mr-2">mdi-information-outline</v-icon>
                No document chunks found for this node.
              </div>
            </div>
          </div>
          <!-- Fallback: parsed VectorContext chunks -->
          <div v-else-if="contextChunks.length > 0">
            <div class="ctx-section">
              <div class="ctx-info-box">
                <v-icon size="16" color="#1976d2" class="mr-2">mdi-information-outline</v-icon>
                No document node IDs found in workflow. Showing parsed context chunks from VectorContext.
              </div>
            </div>
            <div class="ctx-section">
              <div class="ctx-chunks-list">
                <div v-for="(chunk, idx) in contextChunks" :key="idx" class="ctx-chunk-card">
                  <div class="ctx-chunk-top">
                    <div class="ctx-chunk-badges">
                      <span class="ctx-chunk-id">{{ idx + 1 }}</span>
                    </div>
                    <div class="ctx-chunk-doc-name">
                      {{ parseChunkMetadata(chunk).title || '-' }}
                    </div>
                  </div>
                  <div class="ctx-chunk-meta-row">
                    <span v-if="parseChunkMetadata(chunk).topic" class="ctx-chunk-meta-tag">{{ parseChunkMetadata(chunk).topic }}</span>
                    <span v-if="parseChunkMetadata(chunk).source" class="ctx-chunk-meta-tag">{{ parseChunkMetadata(chunk).source }}</span>
                    <span v-if="parseChunkMetadata(chunk).location" class="ctx-chunk-meta-tag">{{ parseChunkMetadata(chunk).location }}</span>
                  </div>
                  <div class="ctx-chunk-content" @click="copyContextText(parseChunkMetadata(chunk).content)" :title="parseChunkMetadata(chunk).content + ' (Click to copy)'">
                    {{ parseChunkMetadata(chunk).content || '-' }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- #End# Group Verdict: Scoring Prompts only (no chunks/workflow) -->
          <div v-else-if="isEndMarkDialog && parsedRagasRawDetail.length > 0">
            <div class="ctx-section">
              <div class="ctx-section-label" style="margin-bottom: 8px;">
                <v-icon size="15" class="mr-1" style="opacity: 0.5;">mdi-chart-box-outline</v-icon>
                Scoring Prompts
                <span class="ctx-tab-count" style="margin-left: 6px;">{{ parsedRagasRawDetail.length }}</span>
              </div>
              <div v-for="tab in parsedRagasRawDetail" :key="tab.key" class="ctx-metric-card">
                <div class="ctx-metric-header" @click="toggleMetricExpand(tab.key)">
                  <div class="ctx-metric-header-left">
                    <v-icon size="16" :color="expandedMetrics[tab.key] ? '#1976d2' : '#94a3b8'" class="mr-2">
                      {{ expandedMetrics[tab.key] ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
                    </v-icon>
                    <span class="ctx-metric-label">{{ tab.label }}</span>
                  </div>
                  <div class="ctx-metric-header-right">
                    <v-chip size="x-small" variant="tonal" color="primary" v-if="tab.prompt">Prompt</v-chip>
                    <v-chip size="x-small" variant="tonal" color="success" v-if="tab.response">Response</v-chip>
                  </div>
                </div>
                <div v-show="expandedMetrics[tab.key]" class="ctx-metric-body">
                  <!-- Prompt -->
                  <div class="ctx-metric-block">
                    <div class="ctx-metric-block-header">
                      <v-icon size="14" class="mr-1" style="opacity:0.5;">mdi-arrow-right-bold-box-outline</v-icon>
                      Prompt
                      <button class="ctx-copy-btn" @click.stop="copyContextText(tab.prompt)" title="Copy">
                        <v-icon size="14">mdi-content-copy</v-icon>
                      </button>
                    </div>
                    <pre class="ctx-ragas-pre">{{ tab.prompt || 'No prompt available' }}</pre>
                  </div>
                  <!-- LLM Response -->
                  <div class="ctx-metric-block">
                    <div class="ctx-metric-block-header">
                      <v-icon size="14" class="mr-1" style="opacity:0.5;">mdi-arrow-left-bold-box-outline</v-icon>
                      LLM Response
                      <button class="ctx-copy-btn" @click.stop="copyContextText(tab.response)" title="Copy">
                        <v-icon size="14">mdi-content-copy</v-icon>
                      </button>
                    </div>
                    <pre class="ctx-ragas-pre">{{ formatJsonSafe(tab.response) }}</pre>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- No data -->
          <div v-else class="ctx-empty-state">
            <v-icon size="36" style="opacity: 0.2; margin-bottom: 8px;">mdi-file-document-remove-outline</v-icon>
            <span class="ctx-empty-label">No document context available for this item.</span>
          </div>
        </div>

        <!-- Footer -->
        <div class="ctx-footer">
          <button class="ctx-close-btn" @click="dialogContext = false">Close</button>
        </div>
      </div>
    </v-dialog>

    <v-overlay  :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import { Chart } from 'highcharts-vue';
import dateUtils from '../plugins/date-utils';
import moment from 'moment';
import Cookies from 'js-cookie';
export default {
  name: 'DashboardScore',
  inject:['FontColorTitle'],
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('DashboardScore');
    },
    currentLanguage() {
      return this.$i18n.locale;
    },
    isEndMarkDialog() {
      return this.contextDialogItem?.question?.trim() === '#End#';
    },
    parsedRagasRawDetail() {
      if (!this.contextDialogItem?.ragasRawDetail) return [];
      try {
        const raw = JSON.parse(this.contextDialogItem.ragasRawDetail);
        const tabs = [];
        const metricMap = {
          faithfulness: 'Faithfulness',
          answer_relevancy: 'Answer Relevancy',
          context_precision: 'Context Precision',
          context_recall: 'Context Recall'
        };
        for (const [key, label] of Object.entries(metricMap)) {
          if (raw[key]) {
            tabs.push({
              key, label,
              prompt: raw[key].prompt || null,
              response: raw[key].response || null
            });
          }
        }
        if (!tabs.length && raw.prompt) {
          tabs.push({
            key: 'aspect_critic', label: 'Aspect Critic',
            prompt: raw.prompt || null,
            response: raw.response || null
          });
        }
        return tabs;
      } catch { return []; }
    },
    viewModeOptions() {
      const opts = [];
      if (this.IsScore && this.isProcessRagas) {
        opts.push({ value: 'combined', text: 'Combined (GPT + RAGAS)' });
      }
      if (this.IsScore) {
        opts.push({ value: 'normal', text: 'GPT Score' });
      }
      if (this.isProcessRagas) {
        opts.push({ value: 'ragas', text: 'RAGAS Score' });
      }
      return opts;
    },
    isViewingHistoricalRun() {
      return this.currentRunProcessId && this.viewProcessID !== this.currentRunProcessId;
    },
    isChainProcess() {
      return this.dataTable && this.dataTable.some(item => item.question && item.question.trim() === '#End#');
    },
    ragasMetricList() {
      return [
        { key: 'faithfulness', label: 'Faithfulness' },
        { key: 'answerRelevancy', label: 'Answer Relevancy' },
        { key: 'contextPrecision', label: 'Context Precision' },
        { key: 'contextRecall', label: 'Context Recall' },
      ];
    },
    headers() {
      let cols = [
          { title: this.$t('no'), align: 'left', sortable: false, width: '50px' },
          { title: this.$t('question'), align: 'left', sortable: true, value: 'Question', width: '250px' },
          { title: this.$t('answer'), align: 'left', sortable: true, value: 'Answer', width: '350px' },
          { title: this.$t('HumanAnswer'), align: 'left', sortable: true, value: 'HumanAnswer', width: '350px' },
      ];
      if (this.isScoreMode) {
          cols.push({ title: this.$t('score'), align: 'left', sortable: true, value: 'Score', width: '80px' });
        }
      if (this.isScoreMode) {
          cols.push({ title: 'GPT Reason', align: 'left', sortable: false, value: 'Reason', width: '450px' });
      }
      if (this.isRagasMode) {
          cols.push(
              { title: 'Faithfulness', align: 'center', sortable: false, value: 'RagasFaithfulness', width: '110px' },
              { title: 'Answer Relevancy', align: 'center', sortable: false, value: 'RagasAnswerRelevancy', width: '110px' },
              { title: 'Context Precision', align: 'center', sortable: false, value: 'RagasContextPrecision', width: '110px' },
              { title: 'Context Recall', align: 'center', sortable: false, value: 'RagasContextRecall', width: '110px' },
              { title: 'RAGAS Reason', align: 'left', sortable: false, width: '500px' },
          );
      }
      cols.push({ title: this.$t('Chat workflow'), align: 'left', sortable: false, value: 'ChatWorkFlow', width: '300px' });
      cols.push({ title: 'Status', align: 'center', sortable: false, width: '90px' });
      cols.push({ title: 'Context Detail', align: 'center', sortable: false, width: '120px' });
      return cols;
    },
  },

  watch: {
    currentLanguage(newLanguage) {
      // อัปเดตข้อความหรือสถานะ component เมื่อภาษาเปลี่ยน
      this.loadTranslations(newLanguage); // เรียกฟังก์ชันเพื่อโหลดข้อมูลหรือข้อความใหม่
    },
    options: {
      handler() {
        if (!this.isInitialized) return;
        this.GetTable();
      },
      deep: true,
    },
  },
  components: {
    highcharts: Chart,
  },
  data: () => ({
    props: ['id'],
    mask: '##########',
    isInitialized: false,
    show1: false,
    dialog: false,
    loading: false,
    loadingbtn: false,
    userList: [],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    isFirst: true,
    userId: Cookies.get('userId'),
    today: null,
    averageScore: 0,
    graphcategories: [],
    graphdata: [],
    language: 'th',
    DDValidationProcess: [],
    ProcessID: null,
    viewProcessID: null,
    currentRunProcessId: null,
    currentRunIsScore: false,
    currentRunIsRagas: false,
    ModelID: null,
    ModelName: null,
    Version: null,
    _pendingVersion: null,
    processDate: null,

    rules: {
      required: (value) => !!value || 'Required',
    },
    isChartOptions: false,
    chartOptions: {
      chart: { type: 'column' },
      title: { text: '' },
      subtitle: { text: '' },
      credits: { enabled: false },
      xAxis: { categories: ['1x', '2x', '3x', '4x'], crosshair: true },
      yAxis: { min: 0, title: { text: 'จำนวนคน' } },
      tooltip: {
        enabled: false,
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b> {point.y:,.0f} คน</b></td></tr>',
        footerFormat: '</table>',
        shared: false,
        useHTML: false,
      },
      plotOptions: {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString() + ' คน';
            },
          },
        },
      },
      series: [
        {
          name: 'จำนวนคน',
          data: [1000000, 1, 1, 1],
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, '#9747FF'],
              [1, '#5179EF'],
            ],
          },
        },
      ],
      
    },
    sortBy: [],
    sortDesc :[],
    dialogReprocess: false,
    DDGPTModel: [],
    Prompt: null,
    IsScore: false,
    Reprocess:{
      modelId: null,
      isScore: false,
      isRagas: false,
      Prompt: null,
    },
    showScoreDetails: false,
    showRagasDetails: false,
    expandedCells: {},
    showAllText: false,
    dialogContext: false,
    contextDialogItem: null,
    contextLoading: false,
    contextDocuments: [],
    contextChunks: [],
    contextError: null,
    contextDocStep: null,
    contextDocStepDocs: [],
    contextKnowledgeSources: null,
    contextActiveTab: 0,
    contextMainTab: 'chunks',
    expandedMetrics: {},
    viewMode: 'combined',
    historyRuns: [],
    dialogHistory: false,
    isProcessRagas: false,
    isRagasMode: false,
    isScoreMode: false,
    isRagasChartOptions: false,
    ragasOverallScore: 0,
    ragasScores: { faithfulness: 0, answerRelevancy: 0, contextPrecision: 0, contextRecall: 0 },
    ragasChartOptions: {},
    ragasMetricColors: { faithfulness: '#6c757d', answerRelevancy: '#6c757d', contextPrecision: '#6c757d', contextRecall: '#6c757d' },
  }),
  methods: {
    loadTranslations(newLanguage) {
      this.language = newLanguage;
      let p = this.$t('setup_table_value');
      this.chartOptions.title = { text: this.$t('validationScore') };
      this.chartOptions.yAxis = {
        min: 0,
        title: { text: this.$t('NumberData') },
      };
      this.chartOptions.plotOptions = {
        column: {
          pointPadding: 0,
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            formatter: function () {
              return parseFloat(this.y.toFixed(2)).toLocaleString() + ` ${p}`;
            },
          },
        },
      };
      this.chartOptions.series = [
        {
          name: this.$t('NumberData'),
          data: this.graphdata,
          color: {
            linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
            stops: [
              [0, '#9747FF'],
              [1, '#5179EF'],
            ],
          },
        },
      ];
    },
    ConvertFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    roundToTwoDecimalPlaces(number) {
      return Math.round((number + Number.EPSILON) * 100) / 100;
    },
    GetTable() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        page: page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        ProcessID: self.viewProcessID || self.ProcessID,
        UserID: self.userId,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      self.$call.GetTableValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst ? dataResponse.data.total : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    SearchData(){
      let self = this;
      self.viewProcessID = self.ProcessID;
      const selected = self.DDValidationProcess.find(p => p.id === self.ProcessID);
      self.isRagasMode = selected?.isRagas === true;
      self.isScoreMode = selected?.isScore === true;
      self.isProcessRagas = selected?.isRagas === true;
      // Set view mode based on selected process
      if (self.isScoreMode && self.isRagasMode) {
        self.viewMode = 'combined';
      } else if (self.isRagasMode) {
        self.viewMode = 'ragas';
      } else {
        self.viewMode = 'normal';
      }
      self.Get();
      self.GetTable();
      if (self.isRagasMode) {
        self.GetRagas();
      }
      self.GetRelatedScoringRuns();
    },
    Get() {
      let self = this;
      self.dialog = true;
      if (!self.isRagasMode) {
        self.isRagasChartOptions = false;
      }
      this.options.page = 1;
      let temp = {
        ProcessID: self.viewProcessID || self.ProcessID,
        UserID: self.userId,
      };
      self.$call.GetDashboardValidationScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const data = dataResponse.data;
            self.averageScore = self.roundToTwoDecimalPlaces(data.averageScore);
            self.graphcategories = data.categories;
            self.graphdata = data.data;
            self.ModelID = data.modelDisplayID;
            self.ModelName = data.modelName;
            self.Version = self._pendingVersion != null ? self._pendingVersion : data.version;
            self._pendingVersion = null;
            self.Prompt = data.prompt;
            self.IsScore = data.isScore;
            self.processDate = data.processDate ? data.processDate.split(' ')[0].replace(/(\d{4})$/, (y) => parseInt(y) > 2500 ? parseInt(y) - 543 : y) : data.processDate;
            self.chartOptions.xAxis.categories = self.graphcategories;

            let p = self.$t('setup_table_value');
            self.chartOptions.title = { text: self.$t('validationScore') };
            self.chartOptions.yAxis = {
              min: 0,
              title: { text: self.$t('NumberData') },
            };
            self.chartOptions.plotOptions = {
              column: {
                pointPadding: 0,
                borderWidth: 0,
                dataLabels: {
                  enabled: true,
                  formatter: function () {
                    return parseFloat(this.y.toFixed(2)).toLocaleString() + ` ${p}`;
                  },
                },
              },
            };
            self.chartOptions.series = [
              {
                name: self.$t('NumberData'),
                data: self.graphdata,
                color: {
                  linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
                  stops: [
                    [0, '#9747FF'],
                    [1, '#5179EF'],
                  ],
                },
              },
            ];

            self.isChartOptions = true;
          }
          self.GetDDValidationProcess();
        },
        (errorResource) => {
          self.dialog = false;
          self.Adddialog = false;
          self.GetDDValidationProcess();
          console.error(errorResource);
        }
      );
    },
    GetDDValidationProcess() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDValidationProcess(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDValidationProcess = dataResponse.data;
          } else {
            self.DDValidationProcess = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    ProcessingScore() {
      let self = this;
      self.$swal.fire({
        title: this.$t('vectorReprocess'),
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes'),
        cancelButtonText: this.$t('cancel'),

      }).then((result) => {
        if (result.isConfirmed) {
          self.dialog = true;
          self.loadingbtn = true;
          let temp = {
            ProcessID: self.viewProcessID || self.ProcessID,
            UserID: self.userId,
          };
          self.$call.GenerateValidationScore(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: 'success',
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.$router.push('/ValidationProcess');
              }
              self.dialog = false;
              self.loadingbtn = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.loadingbtn = false;
              console.error(errorResource);
            }
          );
        }
      })

    },
    convertDateToStringEn(date, seperator = '/') {
      return dateUtils.getStringWithMonthEnNameFromDate(moment(date).toDate(), seperator);
    },
    convertDateToStringTh(date, seperator = '/') {
      return dateUtils.getStringWithMonthNameFromDate(moment(date).toDate(), seperator);
    },
    OpenDialogReprocess() {
      let self = this;
      self.dialogReprocess = true;
      self.Reprocess.modelId = self.ModelID;
      self.Reprocess.isScore = self.IsScore;
      self.Reprocess.isRagas = self.isProcessRagas;
      self.Reprocess.Prompt = self.Prompt;
    },
    CloseDialogReprocess() {
      let self = this;
      self.dialogReprocess = false;
      self.Reprocess.modelId = null;
      self.Reprocess.isScore = false;
      self.Reprocess.isRagas = false;
      self.Reprocess.Prompt = null;
    },
    handleReprocessScoreChange() {
      // Both checkboxes can be active simultaneously
    },
    handleReprocessRagasChange() {
      // Both checkboxes can be active simultaneously
    },
    ReProcess(){
      let self = this;
        console.log(self.Reprocess);
        console.log(self.CheckNullInVariable(self.Reprocess.modelId));
      if(!self.CheckNullInVariable(self.Reprocess.modelId))
      {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please select a model.",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      else if(self.Reprocess.isScore == true && !self.CheckNullInVariable(self.Reprocess.Prompt))
      {
        self.$swal.fire({
          icon: "warning",
          title: self.$t("warning"),
          text: "Please enter the prompt.",
          showConfirmButton: false,
          timer: 2000,
        });
        return false;
      }
      self.dialog = true;
      self.loadingbtn = true;
      let temp = {
        ProcessID: self.ProcessID,
        ModelID: self.Reprocess.modelId,
        IsScore: self.Reprocess.isScore,
        IsRagas: self.Reprocess.isRagas,
        Prompt: self.Reprocess.Prompt,
      };
      self.$call.SetReprocessValidationProcess(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.$swal.fire({
              icon: 'success',
              title: dataResponse.message,
              showConfirmButton: false,
              timer: 1500,
            });
            self.$router.push('/ValidationProcess');
          }
          self.dialog = false;
          self.loadingbtn = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.loadingbtn = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      self.dialog = true;
      self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          // self.GetValidationGenerateDD();
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetRagas() {
      let self = this;
      let temp = {
        ProcessID: self.viewProcessID || self.ProcessID,
        UserID: self.userId,
      };
      self.$call.GetRagasDashboardScore(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const data = dataResponse.data;
            self.ragasOverallScore = parseFloat(data.overallScore || 0).toFixed(4);
            self.ragasScores = {
              faithfulness: parseFloat(data.faithfulness || 0),
              answerRelevancy: parseFloat(data.answerRelevancy || 0),
              contextPrecision: parseFloat(data.contextPrecision || 0),
              contextRecall: parseFloat(data.contextRecall || 0),
            };
            self.ragasMetricColors = {
              faithfulness: self.getScoreColor(parseFloat(data.faithfulness || 0)),
              answerRelevancy: self.getScoreColor(parseFloat(data.answerRelevancy || 0)),
              contextPrecision: self.getScoreColor(parseFloat(data.contextPrecision || 0)),
              contextRecall: self.getScoreColor(parseFloat(data.contextRecall || 0)),
            };
            self.ragasChartOptions = {
              chart: { type: 'column', height: (self.isScoreMode && self.isRagasMode) ? 340 : 390 },
              title: { text: 'RAGAS Validation Score' },
              subtitle: { text: '' },
              credits: { enabled: false },
              legend: { enabled: false },
              xAxis: {
                categories: ['Faithfulness', 'Answer Relevancy', 'Context Precision', 'Context Recall'],
                crosshair: true,
              },
              yAxis: {
                min: 0,
                max: 1,
                tickInterval: 0.10,
                title: { text: 'Score' },
              },
              tooltip: {
                useHTML: true,
                shadow: false,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                borderColor: '#cccccc',
                formatter: function () {
                  return '<span style="font-size:12px; font-weight:700;">' + this.key + '</span><br/>' +
                    '<span style="font-weight:600;">Avg Score: <b>' + this.y.toFixed(4) + '</b></span><br/>' +
                    '<span style="font-weight:600;">Total Questions: <b>' + self.searchTotalTable + '</b></span>';
                },
              },
              plotOptions: {
                column: {
                  pointPadding: 0,
                  borderWidth: 0,
                  dataLabels: {
                    enabled: true,
                    format: '{y:.4f}',
                  },
                },
              },
              series: [{
                  name: 'RAGAS Metrics',
                  data: [
                    { y: parseFloat(data.faithfulness || 0), color: self.getScoreColor(parseFloat(data.faithfulness || 0)) },
                    { y: parseFloat(data.answerRelevancy || 0), color: self.getScoreColor(parseFloat(data.answerRelevancy || 0)) },
                    { y: parseFloat(data.contextPrecision || 0), color: self.getScoreColor(parseFloat(data.contextPrecision || 0)) },
                    { y: parseFloat(data.contextRecall || 0), color: self.getScoreColor(parseFloat(data.contextRecall || 0)) },
                  ],
                  colorByPoint: true,
              }],
            };
            self.isRagasChartOptions = true;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    GetRelatedScoringRuns() {
      let self = this;
      let temp = {
        ProcessID: self.viewProcessID || self.ProcessID,
      };
      self.$call.GetRelatedScoringRuns(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            const result = dataResponse.data || {};
            // Store history runs
            self.historyRuns = (result.history || []).map(r => ({
              ...r,
              displayScoringType: (r.scoringType || '').replace(/Normal/g, 'GPT'),
              displayName: (r.scoringType || '').replace(/Normal/g, 'GPT') + ' Score (' + r.date + ')'
            }));
            // Remember the process's actual scoring capabilities
            if (result.currentRun) {
              self.currentRunProcessId = result.currentRun.processId;
              const st = result.currentRun.scoringType || '';
              self.currentRunIsScore = st.includes('Normal');
              self.currentRunIsRagas = st.includes('RAGAS');
              self.isProcessRagas = st.includes('RAGAS');
              // Set initial view mode based on current modes
              if (self.isScoreMode && self.isRagasMode) {
                self.viewMode = 'combined';
              } else if (self.isRagasMode) {
                self.viewMode = 'ragas';
              } else {
                self.viewMode = 'normal';
              }
            }
          } else {
            self.historyRuns = [];
          }
        },
        (errorResource) => {
          self.historyRuns = [];
          console.error(errorResource);
        }
      );
    },
    onViewModeChange(mode) {
      let self = this;
      switch (mode) {
        case 'combined':
          self.isScoreMode = true;
          self.isRagasMode = true;
          break;
        case 'normal':
          self.isScoreMode = true;
          self.isRagasMode = false;
          break;
        case 'ragas':
          self.isScoreMode = false;
          self.isRagasMode = true;
          break;
      }
      // If switching to a mode that includes RAGAS and chart data hasn't been fetched yet
      if (self.isRagasMode && !self.isRagasChartOptions) {
        self.GetRagas();
      }
    },
    onHistoryRunSelect(run) {
      let self = this;
      if (!run || !run.processId || run.processId === self.viewProcessID) return;
      self.dialogHistory = false;

      // Update viewProcessID (not ProcessID, to keep autocomplete in sync)
      self.viewProcessID = run.processId;

      // Determine scoring modes from the selected historical run
      const st = run.scoringType || '';
      self.isRagasMode = st.includes('RAGAS');
      self.isScoreMode = st.includes('Normal');
      self.isProcessRagas = st.includes('RAGAS');

      // Set view mode based on the run's capabilities
      if (self.isScoreMode && self.isRagasMode) {
        self.viewMode = 'combined';
      } else if (self.isRagasMode) {
        self.viewMode = 'ragas';
      } else {
        self.viewMode = 'normal';
      }

      // Compute the version number for the selected run
      const idx = self.historyRuns.findIndex(r => r.processId === run.processId);
      if (idx >= 0) {
        self._pendingVersion = self.historyRuns.length - idx;
      }

      // Re-fetch data
      self.Get();
      self.GetTable();
      if (self.isRagasMode) {
        self.GetRagas();
      }
    },
    goBackToCurrentRun() {
      let self = this;
      self.viewProcessID = self.currentRunProcessId;
      self.isScoreMode = self.currentRunIsScore;
      self.isRagasMode = self.currentRunIsRagas;
      self.isProcessRagas = self.currentRunIsRagas;
      if (self.isScoreMode && self.isRagasMode) self.viewMode = 'combined';
      else if (self.isRagasMode) self.viewMode = 'ragas';
      else self.viewMode = 'normal';
      self.Get();
      self.GetTable();
      if (self.isRagasMode) self.GetRagas();
    },
    getScoreColor(score) {
      if (score >= 0.90) return '#43a047';  // Green — High
      if (score >= 0.60) return '#f9a825';  // Yellow/Orange — Medium
      return '#e53935';                      // Red — Low
    },
    hasAnyRagasReason(item) {
      return item.ragasFaithfulnessReason || item.ragasAnswerRelevancyReason ||
             item.ragasContextPrecisionReason || item.ragasContextRecallReason;
    },
    getFirstRagasReason(item) {
      const reasons = [
        item.ragasFaithfulnessReason ? `Faithfulness: ${item.ragasFaithfulnessReason}` : null,
        item.ragasAnswerRelevancyReason ? `Answer Relevancy: ${item.ragasAnswerRelevancyReason}` : null,
        item.ragasContextPrecisionReason ? `Context Precision: ${item.ragasContextPrecisionReason}` : null,
        item.ragasContextRecallReason ? `Context Recall: ${item.ragasContextRecallReason}` : null,
      ].filter(Boolean);
      return reasons.join(' | ');
    },
    formatWorkflow(chatWorkFlowStr) {
      if (!chatWorkFlowStr) return '';
      try {
        const steps = JSON.parse(chatWorkFlowStr);
        if (!Array.isArray(steps) || steps.length === 0) return chatWorkFlowStr;

        const sorted = steps.sort((a, b) => (a.Order ?? a.order ?? 0) - (b.Order ?? b.order ?? 0));
        const parts = [];
        let hasResponse = false;

        for (const step of sorted) {
          const node = step.Node ?? step.node ?? '?';
          const output = step.Output ?? step.output;
          const workflowDetail = output?.Workflow ?? output?.workflow;
          const model = output?.Model ?? output?.model;
          const status = step.Status ?? step.status;

          if (workflowDetail) {
            const entries = workflowDetail.split('>').filter(s => s.trim());
            parts.push(...entries);
          } else if (node === 'model' || node === 'aiModel') {
            parts.push(model ? `Call Bot (${model})` : 'Call Bot');
          } else if (node === 'response') {
            hasResponse = true;
            continue;
          } else if (node === 'embedding') {
            parts.push('Convert to Embedding');
          } else if (node === 'summaryMemory') {
            parts.push('Summary Documents Memory');
          } else {
            const displayName = this.formatNodeName(node);
            if (status && status.toLowerCase() !== 'success') {
              parts.push(`${displayName} [${status}]`);
            } else {
              parts.push(displayName);
            }
          }
        }

        if (hasResponse) {
          parts.push('Response Generated');
        }

        return parts.join('>');
      } catch (e) {
        return chatWorkFlowStr;
      }
    },
    truncateText(text, limit) {
      if (!text || text.length <= limit) return text || '';
      return text.substring(0, limit) + '...';
    },
    toggleCell(rowId, field) {
      const key = `${rowId}_${field}`;
      this.expandedCells = { ...this.expandedCells, [key]: !this.expandedCells[key] };
    },
    isExpanded(rowId, field) {
      if (this.showAllText) return true;
      return !!this.expandedCells[`${rowId}_${field}`];
    },
    CheckNullInVariable(variable) {
      if(variable == null || variable == undefined || variable == "")
      {
        return false;
      }
      else
      {
        return true;
      }
    },
    openContextDialog(item) {
      this.contextDialogItem = item;
      this.contextDocuments = [];
      this.contextChunks = [];
      this.contextDocStep = null;
      this.contextDocStepDocs = [];
      this.contextKnowledgeSources = null;
      this.contextActiveTab = 0;
      this.contextMainTab = 'chunks';
      this.expandedMetrics = {};
      this.contextError = null;
      this.contextLoading = true;
      this.dialogContext = true;

      // #End# group verdict: no workflow/documents to fetch, just show scoring prompts
      if (item.question && item.question.trim() === '#End#') {
        this.contextMainTab = 'scoring';
        this.contextLoading = false;
        return;
      }

      try {
        const rawWorkflow = item.chatWorkFlow ? JSON.parse(item.chatWorkFlow) : null;
        if (rawWorkflow && Array.isArray(rawWorkflow)) {
          // Normalize PascalCase keys to camelCase
          const workflow = rawWorkflow.map(step => ({
            node: step.Node ?? step.node,
            status: step.Status ?? step.status,
            startTime: step.StartTime ?? step.startTime,
            endTime: step.EndTime ?? step.endTime,
            responseTimeMs: step.ResponseTimeMs ?? step.responseTimeMs,
            input: {
              message: (step.Input && step.Input.Message) ?? (step.input && step.input.message) ?? ''
            },
            output: {
              message: (step.Output && step.Output.Message) ?? (step.output && step.output.message) ?? '',
              workflow: (step.Output && step.Output.Workflow) ?? (step.output && step.output.workflow) ?? ''
            },
            logRefs: step.LogRefs ?? step.logRefs ?? []
          }));

          // Find the document-related node
          const docNodeTypes = ['documents', 'community', 'community+documents'];
          const docStep = workflow.find(s => docNodeTypes.includes(s.node));

          if (docStep) {
            this.contextDocStep = docStep;
            this.contextKnowledgeSources = this.parseWorkflowSources(docStep.output.workflow, docStep.node);

            // Extract vector IDs and fetch document references
            let vectorIds = [];
            if (docStep.logRefs && Array.isArray(docStep.logRefs) && docStep.logRefs.length > 0) {
              vectorIds = docStep.logRefs;
            } else if (docStep.output && docStep.output.message) {
              try {
                const ids = JSON.parse(docStep.output.message);
                if (Array.isArray(ids)) vectorIds = ids.map(Number).filter(n => !isNaN(n));
              } catch (e) { /* not JSON array */ }
            }

            if (vectorIds.length > 0) {
              const request = { ID: vectorIds };
              const nodeType = docStep.node;
              // For community+documents: determine which IDs are community vs document
              // Vector IDs are ordered: community chunks first, then document chunks
              const communityChunkCount = (this.contextKnowledgeSources && this.contextKnowledgeSources.community)
                ? this.contextKnowledgeSources.community.chunks : 0;
              const communityIdSet = (nodeType === 'community+documents' && communityChunkCount > 0)
                ? new Set(vectorIds.slice(0, communityChunkCount)) : null;

              let apiResolved = false;
              // Safety timeout: stop loading after 10s if API never responds
              const loadingTimeout = setTimeout(() => {
                if (!apiResolved) {
                  apiResolved = true;
                  this.contextLoading = false;
                }
              }, 10000);
              this.$call.GetLogDocumentReferenceFromLog(
                request,
                (response) => {
                  if (apiResolved) return;
                  apiResolved = true;
                  clearTimeout(loadingTimeout);
                  let docs = [];
                  if (response && response.data && response.data.result && Array.isArray(response.data.result)) {
                    docs = response.data.result;
                  } else if (response && response.data && Array.isArray(response.data)) {
                    docs = response.data;
                  }
                  // Add source field based on node type
                  this.contextDocStepDocs = docs.map(item => ({
                    ...item,
                    source: nodeType === 'community'
                      ? 'community'
                      : (communityIdSet && communityIdSet.has(item.id))
                        ? 'community'
                        : (item.source || 'document')
                  }));
                  this.contextLoading = false;
                },
                (error) => {
                  if (apiResolved) return;
                  apiResolved = true;
                  clearTimeout(loadingTimeout);
                  console.error('Error fetching document references:', error);
                  this.contextLoading = false;
                }
              );
              return;
            }

            this.contextLoading = false;
            return;
          }
          // Workflow exists but no document node — fall through to VectorContext
        }
      } catch (e) {
        // chatWorkFlow is not valid JSON, fall through to fallback
      }

      // Fallback: parse VectorContext
      if (item.vectorContext) {
        this.contextChunks = this.extractContexts(item.vectorContext);
      }
      this.contextLoading = false;
    },
    extractContexts(vectorContext) {
      if (!vectorContext || !vectorContext.trim()) return [];

      if (vectorContext.startsWith('[No Vector Context]')) return [];

      // 1. Try document vector format: ###infoN###content
      const infoPattern = /###info\d+###\s*([\s\S]*?)(?=###info\d+###|$)/g;
      let matches = [];
      let match;
      while ((match = infoPattern.exec(vectorContext)) !== null) {
        const content = match[1].trim();
        if (content) matches.push(content);
      }
      if (matches.length > 0) return matches;

      // 2. Try Community Graph format: **Topic N** and [Source N]
      const communityContexts = [];
      const topicPattern = /\*\*Topic\s+\d+\*\*[^\n]*\n([\s\S]*?)(?=\*\*Topic\s+\d+\*\*|\[Source\s+\d+\]|### |$)/g;
      while ((match = topicPattern.exec(vectorContext)) !== null) {
        const content = match[1].trim();
        if (content) communityContexts.push(content);
      }
      const sourcePattern = /\[Source\s+\d+\][^\n]*\n([\s\S]*?)(?=\[Source\s+\d+\]|\*\*Topic\s+\d+\*\*|### |$)/g;
      while ((match = sourcePattern.exec(vectorContext)) !== null) {
        const content = match[1].trim();
        if (content) communityContexts.push(content);
      }
      if (communityContexts.length > 0) return communityContexts;

      // 3. Try generic ### Section ### headers
      const sectionPattern = /###\s+[^#]+\s+###\s*([\s\S]*?)(?=###\s+[^#]+\s+###|$)/g;
      const sectionContexts = [];
      while ((match = sectionPattern.exec(vectorContext)) !== null) {
        const content = match[1].trim();
        if (content) sectionContexts.push(content);
      }
      if (sectionContexts.length > 0) return sectionContexts;

      // 4. Fallback: entire string as single context
      return [vectorContext.trim()];
    },
    parseChunkMetadata(chunk) {
      const result = { title: '', topic: '', source: '', location: '', content: '' };
      if (!chunk) return result;
      const lines = chunk.split('\n');
      const contentLines = [];
      const locationParts = [];
      for (const line of lines) {
        const trimmed = line.trim();
        if (/^title\s*:/i.test(trimmed)) {
          result.title = trimmed.replace(/^title\s*:\s*/i, '');
        } else if (/^sub-topic\s*:/i.test(trimmed)) {
          result.topic = result.topic ? result.topic + ' > ' + trimmed.replace(/^sub-topic\s*:\s*/i, '') : trimmed.replace(/^sub-topic\s*:\s*/i, '');
        } else if (/^topic\s*:/i.test(trimmed)) {
          const topicVal = trimmed.replace(/^topic\s*:\s*/i, '');
          result.topic = result.topic ? topicVal + ' > ' + result.topic : topicVal;
        } else if (/^source\s*:/i.test(trimmed)) {
          result.source = trimmed.replace(/^source\s*:\s*/i, '');
        } else if (/^Page\s*:/i.test(trimmed)) {
          locationParts.push(trimmed);
        } else if (/^Line\s*:/i.test(trimmed)) {
          locationParts.push(trimmed);
        } else {
          contentLines.push(trimmed);
        }
      }
      result.location = locationParts.join(', ');
      result.content = contentLines.filter(l => l).join('\n');
      return result;
    },
    parseWorkflowSources(workflowStr, nodeType) {
      const sources = { community: null, documents: null, mode: nodeType };
      if (!workflowStr) return sources;

      // Parse Community Graph: >Community Graph Search (CommunityId=65, Groups=16, Chunks=0)
      const communityMatch = workflowStr.match(/Community Graph Search\s*\(CommunityId=(\d+),\s*Groups=(\d+),\s*Chunks=(\d+)\)/);
      if (communityMatch) {
        sources.community = {
          communityId: communityMatch[1],
          groups: parseInt(communityMatch[2]),
          chunks: parseInt(communityMatch[3])
        };
      }

      // Parse Documents: >Document Search (VectorDB=["eng_doc_pk"], Chunks=2, Thread)
      const docMatch = workflowStr.match(/Document Search\s*\(VectorDB=(\[[^\]]*\]),\s*Chunks=(\d+)/);
      if (docMatch) {
        let vectorDB = docMatch[1];
        try { vectorDB = JSON.parse(vectorDB).join(', '); } catch (e) { /* keep raw */ }
        sources.documents = {
          vectorDB: vectorDB,
          chunks: parseInt(docMatch[2])
        };
      }

      return sources;
    },
    formatNodeName(nodeName) {
      const nodeNames = {
        messageInput: 'Message Input',
        intent: 'Intent Router',
        router: 'Router',
        advancedRouter: 'Advanced Router',
        model: 'AI Model',
        cache: 'Cache',
        aiModel: 'AI Model Processing',
        interestOptimizer: 'Interest Optimizer',
        response: 'Message Output',
        apiknowledge: 'API Knowledge',
        databaseIntegration: 'DB Integration',
        apiTrigger: 'API Trigger',
        contactAgent: 'Contact Agent',
        contactAgentV2: 'Contact Agent V2',
        loanInterest: 'Loan Interest',
        interestOptimizerV2: 'Interest Optimizer V2',
        loanInterestV2: 'Loan Interest V2',
        documents: 'Documents',
        community: 'Community Graph',
        'community+documents': 'Community + Documents',
        embedding: 'Vector Embedding',
        summaryMemory: 'Summary Documents Memory',
        queryRewriter: 'Query Rewriter',
        smartIntent: 'Smart Intent',
        reformatForTTS: 'Reformat For TTS',
        formatForTTSEngine: 'Format For TTS Engine',
        orchestrator: 'Orchestrator',
        'agent-tool': 'Tool',
        agent: 'Agent (Find tools)',
        'agent-aimodel': 'Agent (Summary)',
        serviceFallback: 'Service Fallback',
        jsonCondition: 'JSON Condition',
      };
      return nodeNames[nodeName] || nodeName;
    },
    formatStepTime(dateStr) {
      if (!dateStr) return '-';
      try {
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      } catch (e) {
        return dateStr;
      }
    },
    getStepStatusColor(status) {
      const colors = {
        Success: 'green',
        success: 'green',
        Error: 'red',
        error: 'red',
        warning: 'orange',
        pending: 'blue',
        processing: 'purple',
      };
      return colors[status] || 'grey';
    },
    formatShortDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
    isDocExpired(doc) {
      const now = new Date();
      if (doc.effectiveEndDate && new Date(doc.effectiveEndDate) < now) return true;
      if (doc.effectiveStartDate && new Date(doc.effectiveStartDate) > now) return true;
      return false;
    },
    getDocStatusClass(doc) {
      if (doc.documentActiveStatus != null) {
        if (this.isDocExpired(doc)) return 'ctx-chunk-status--inactive';
        return doc.documentActiveStatus === true ? 'ctx-chunk-status--active' : 'ctx-chunk-status--inactive';
      }
      // Fallback to chunk-level activeFlag
      return doc.activeFlag === true ? 'ctx-chunk-status--active' : doc.activeFlag === false ? 'ctx-chunk-status--inactive' : 'ctx-chunk-status--unknown';
    },
    getDocStatusLabel(doc) {
      if (doc.documentActiveStatus != null) {
        if (this.isDocExpired(doc)) return 'Inactive';
        return doc.documentActiveStatus === true ? 'Active ✓' : 'Inactive';
      }
      // Fallback to chunk-level activeFlag
      return doc.activeFlag === true ? 'Active' : doc.activeFlag === false ? 'Inactive' : '-';
    },
    formatJsonSafe(str) {
      if (!str) return 'No response available';
      try { return JSON.stringify(JSON.parse(str), null, 2); }
      catch { return str; }
    },
    copyContextText(text) {
      if (!text) return;
      navigator.clipboard.writeText(text).catch(() => {});
    },
    toggleMetricExpand(key) {
      this.expandedMetrics = { ...this.expandedMetrics, [key]: !this.expandedMetrics[key] };
    },
  },
  mounted() {
    let self = this;
    self.language = self.$i18n.locale;
    self.GetDDGPTModel();
    if (self.$route.query.id) {
      if (self.$route.query.id != null) {
        self.ProcessID = self.$route.query.id;
        self.viewProcessID = self.$route.query.id;
        self.isRagasMode = self.$route.query.isRagas === 'true';
        self.isScoreMode = self.$route.query.isScore === 'true';
        self.isProcessRagas = self.$route.query.isRagas === 'true';
        // Set initial view mode based on URL params
        if (self.isScoreMode && self.isRagasMode) {
          self.viewMode = 'combined';
        } else if (self.isRagasMode) {
          self.viewMode = 'ragas';
        } else {
          self.viewMode = 'normal';
        }
        self.Get();
        if (self.isRagasMode) {
          self.GetRagas();
        }
        self.GetRelatedScoringRuns();
      }
    }
    self.GetTable();
    self.isInitialized = true;
  },
};
</script>
<style scoped>
.card-1 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 125px;
  flex-shrink: 0;
}

.card-2 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 400px;
  flex-shrink: 0;
}

.ragas-score-line {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.card-3 {
  border-radius: 13px;
  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 160px;
  flex-shrink: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.circular--portrait {
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}

.gradient-red {
  background: -webkit-linear-gradient(red, yellow);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gradient-purple {
  background: -webkit-linear-gradient(#9747ff, #5179ef);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* =============================================================================
   TOOLBAR LAYOUT
   ============================================================================= */
.toolbar-row {
  padding: 12px 16px;
  background: #f8f9fb;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin: 0px 11px;;
}

.toolbar-group {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.modern-field :deep(.v-field) {
  border-radius: 8px !important;
  background: #ffffff !important;
  transition: all 0.2s ease !important;
}

.modern-field :deep(.v-field__outline) {
  border-color: rgba(0, 0, 0, 0.15) !important;
  transition: all 0.2s ease !important;
}

.modern-field :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
}

.modern-field:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.5) !important;
}

.modern-field :deep(.v-label) {
  font-weight: 500 !important;
  font-size: 0.85rem !important;
}

.modern-field :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-field :deep(.v-field__input) {
  font-size: 0.9rem !important;
  font-weight: 500 !important;
  color: #333 !important;
}

.modern-field :deep(.v-field__prepend-inner) {
  padding-right: 6px !important;
}

.modern-field :deep(.v-field__append-inner) {
  padding-left: 6px !important;
}
.modern-textarea {
  margin-top: 8px;
}

.modern-textarea :deep(.v-field) {
  border-radius: 12px !important;
  background: #ffffff !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field__outline) {
  border-width: 2px !important;
  border-color: rgba(0, 0, 0, 0.12) !important;
  transition: all 0.3s ease !important;
}

.modern-textarea :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1) !important;
}

.modern-textarea:hover :deep(.v-field__outline) {
  border-color: rgba(25, 118, 210, 0.6) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

.modern-textarea :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}

.modern-textarea :deep(.v-field--focused .v-label) {
  color: #1976d2 !important;
}

.modern-textarea :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-textarea :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-textarea :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

/* =============================================================================
   MODERN CHECKBOX STYLES
   ============================================================================= */
.modern-checkbox :deep(.v-selection-control) {
  background: rgba(248, 249, 250, 0.8);
  border-radius: 12px;
  padding: 12px 16px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.modern-checkbox :deep(.v-selection-control:hover) {
  background: rgba(248, 249, 250, 1);
  border-color: rgba(25, 118, 210, 0.2);
}

.modern-checkbox :deep(.v-selection-control--dirty) {
  border-color: rgba(25, 118, 210, 0.3);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.checkbox-label-wrapper {
  display: flex;
  align-items: center;
  font-weight: 500;
  color: #495057;
}
.search-btn {
  transition: all 0.2s ease !important;
}

.search-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

/* =============================================================================
   REPROCESS BUTTON ENHANCEMENT
   ============================================================================= */
.back-to-latest-btn {
  transition: all 0.2s ease !important;
}

.reprocess-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  transition: all 0.2s ease !important;
}

.reprocess-btn:disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.history-btn {
  border-radius: 8px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.25px !important;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
.ragas-metric-item {
  font-size: 13px;
  margin-bottom: 6px;
  line-height: 1.5;
}

/* Table Layout */
:deep(.v-data-table-server) {
  overflow-x: auto;
}

:deep(.v-data-table) {
  width: 100%;
}

:deep(.v-data-table table) {
  min-width: 2200px;
}

:deep(.v-data-table th) {
  white-space: nowrap;
  font-size: 0.8rem;
  font-weight: 700;
  padding: 10px 8px;
  background-color: #f5f5f5;
  border-bottom: 2px solid #e0e0e0;
}

/* Text cells */
.text-cell {
  vertical-align: top;
  padding: 8px;
}

.cell-content {
  /* max-height: 120px; */
  overflow-y: auto;
  word-break: break-word;
  line-height: 1.5;
  font-size: 0.85rem;
}

.cell-content.expanded {
  max-height: none;
}

.toggle-text {
  display: inline-block;
  color: #1976d2;
  cursor: pointer;
  font-size: 0.8rem;
  font-weight: 600;
  margin-left: 4px;
}

.toggle-text:hover {
  text-decoration: underline;
}

/* Status dot badges */
.status-dot {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 12px;
  white-space: nowrap;
}
.status-dot::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}
.status-dot--success {
  color: #2e7d32;
  background: #e8f5e9;
}
.status-dot--success::before {
  background: #43a047;
}
.status-dot--error {
  color: #e65100;
  background: #fff3e0;
}
.status-dot--error::before {
  background: #fb8c00;
}

.score-legend {
  background: #fafafa;
  border-radius: 8px;
  padding: 8px 12px;
  margin-top: 4px;
}

.legend-item {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #4c4c4c;
  margin-bottom: 4px;
}

.legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .toolbar-row .toolbar-group {
    flex-wrap: wrap;
  }
}

.show-all-text-switch {
  flex: none;
}
.show-all-text-switch :deep(.v-switch__track) {
  height: 20px;
  min-width: 40px;
}
.show-all-text-switch :deep(.v-switch__thumb) {
  height: 18px;
  width: 18px;
}
.show-all-text-switch :deep(.v-selection-control) {
  min-height: 28px;
}

/* =============================================================================
   CONTEXT DETAIL DIALOG
   ============================================================================= */
/* ── Context Detail dialog ── */
.ctx-dialog {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.14), 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  max-height: 90vh;
}

/* Header */
.ctx-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 24px 16px;
  background: linear-gradient(135deg, #1e3a5f 0%, #2c5282 60%, #2b6cb0 100%);
  color: white;
  flex-shrink: 0;
}
.ctx-header-left {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
  flex: 1;
}
.ctx-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(4px);
  flex-shrink: 0;
}
.ctx-header-title {
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.ctx-header-question {
  font-size: 0.8rem;
  opacity: 0.8;
  margin-top: 3px;
  line-height: 1.4;
  word-break: break-word;
}
.ctx-header-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.12);
  color: white;
  cursor: pointer;
  transition: background 0.15s;
  flex-shrink: 0;
}
.ctx-header-close:hover {
  background: rgba(255, 255, 255, 0.28);
}

/* Body */
.ctx-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

/* Question & Answer summary */
.ctx-qa-summary {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.ctx-qa-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.ctx-qa-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.4px;
  display: flex;
  align-items: center;
}
.ctx-qa-text {
  font-size: 13px;
  color: #1e293b;
  line-height: 1.5;
  word-break: break-word;
}

/* Sections */
.ctx-section {
  margin-bottom: 20px;
}
.ctx-section:last-child {
  margin-bottom: 0;
}
.ctx-section-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
  margin-bottom: 10px;
}
.ctx-section-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: #e2e8f0;
  color: #475569;
  font-size: 0.7rem;
  font-weight: 700;
}

/* Status row */
.ctx-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.ctx-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 650;
  text-transform: capitalize;
}
.ctx-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}
.ctx-status--success { background: #ecfdf5; color: #065f46; }
.ctx-status--success .ctx-status-dot { background: #10b981; }
.ctx-status--error, .ctx-status--failed { background: #fef2f2; color: #991b1b; }
.ctx-status--error .ctx-status-dot, .ctx-status--failed .ctx-status-dot { background: #ef4444; }
.ctx-status--unknown { background: #f1f5f9; color: #64748b; }
.ctx-status--unknown .ctx-status-dot { background: #94a3b8; }
.ctx-node-label {
  display: inline-flex;
  align-items: center;
  font-size: 0.78rem;
  color: #64748b;
  font-weight: 500;
}

/* Input / Output grid */
.ctx-io-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
@media (max-width: 700px) {
  .ctx-io-grid { grid-template-columns: 1fr; }
}
.ctx-io-panel {
  border: 1px solid #e8ecf2;
  border-radius: 10px;
  overflow: hidden;
  background: #fafbfd;
}
.ctx-io-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-bottom: 1px solid #e8ecf2;
  background: #f1f5f9;
}
.ctx-io-title {
  display: flex;
  align-items: center;
  font-size: 0.76rem;
  font-weight: 650;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.ctx-copy-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.15s;
}
.ctx-copy-btn:hover {
  background: #e2e8f0;
  color: #475569;
}
.ctx-code-block {
  margin: 0;
  padding: 10px 12px;
  font-size: 0.78rem;
  font-family: 'SF Mono', 'Fira Code', 'Cascadia Code', 'Consolas', monospace;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 160px;
  overflow-y: auto;
  color: #334155;
  line-height: 1.5;
  background: transparent;
}

/* Knowledge Sources */
.ctx-knowledge-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 10px;
}
.ctx-knowledge-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1px solid #e8ecf2;
  background: #fafbfd;
  transition: border-color 0.15s;
}
.ctx-knowledge-card:hover {
  border-color: #cbd5e1;
}
.ctx-knowledge-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  flex-shrink: 0;
}
.ctx-knowledge-card-body { min-width: 0; }
.ctx-knowledge-card-title {
  font-size: 0.78rem;
  font-weight: 700;
  color: #334155;
}
.ctx-knowledge-card-detail {
  font-size: 0.73rem;
  color: #64748b;
  margin-top: 2px;
  line-height: 1.4;
}
.ctx-mode-badge {
  display: inline-flex;
  align-items: center;
  margin-top: 10px;
  padding: 4px 12px;
  border-radius: 8px;
  background: #f0fdfa;
  color: #0d9488;
  font-size: 0.72rem;
  font-weight: 600;
}

/* Chunk cards */
.ctx-chunks-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.ctx-chunk-card {
  border: 1px solid #e8ecf2;
  border-radius: 10px;
  padding: 12px 14px;
  background: #fafbfd;
  transition: all 0.15s;
}
.ctx-chunk-card:hover {
  border-color: #c7d2e0;
  background: #f5f7fb;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.ctx-chunk-top {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
}
.ctx-chunk-badges {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}
.ctx-chunk-id {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  height: 22px;
  padding: 0 8px;
  border-radius: 6px;
  background: linear-gradient(135deg, #059669 0%, #10b981 100%);
  color: white;
  font-size: 0.68rem;
  font-weight: 700;
  font-family: 'SF Mono', 'Fira Code', monospace;
}
.ctx-chunk-source {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 0.68rem;
  font-weight: 700;
}
.ctx-chunk-source--graph {
  background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
  color: white;
}
.ctx-chunk-source--doc {
  background: linear-gradient(135deg, #2563eb 0%, #3b82f6 100%);
  color: white;
}
.ctx-chunk-status {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 0.68rem;
  font-weight: 650;
}
.ctx-chunk-status--active { background: #ecfdf5; color: #065f46; }
.ctx-chunk-status--inactive { background: #fef2f2; color: #991b1b; }
.ctx-chunk-status--unknown { background: #f1f5f9; color: #94a3b8; }
.ctx-chunk-dates {
  font-size: 0.68rem;
  color: #64748b;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 4px;
  background: #f1f5f9;
}
.ctx-chunk-dates--expired {
  background: #fff7ed;
  color: #c2410c;
}
.ctx-chunk-doc-name {
  display: flex;
  align-items: center;
  font-size: 0.78rem;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ctx-chunk-doc-name:hover {
  color: #2563eb;
}
.ctx-chunk-meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}
.ctx-chunk-meta-tag {
  padding: 2px 8px;
  border-radius: 5px;
  background: #f1f5f9;
  font-size: 0.7rem;
  color: #64748b;
  font-weight: 500;
}
.ctx-chunk-content {
  font-size: 0.78rem;
  color: #475569;
  line-height: 1.55;
  word-break: break-word;
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  max-height: 120px;
  overflow-y: auto;
  transition: background 0.15s;
}
.ctx-chunk-content:hover {
  background: #f1f5f9;
}

/* Utility states */
.ctx-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  gap: 8px;
}
.ctx-empty-label {
  font-size: 0.82rem;
  color: #94a3b8;
  font-weight: 500;
}
.ctx-empty-hint {
  font-size: 0.78rem;
  color: #94a3b8;
  padding: 8px 0;
}
.ctx-error-box {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 10px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
  font-size: 0.82rem;
  font-weight: 500;
}
.ctx-info-box {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 10px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1e40af;
  font-size: 0.82rem;
  font-weight: 500;
}

/* Footer */
.ctx-footer {
  display: flex;
  justify-content: flex-end;
  padding: 14px 24px;
  border-top: 1px solid #e8ecf2;
  background: #fafbfd;
  flex-shrink: 0;
}
.ctx-close-btn {
  padding: 7px 22px;
  border-radius: 8px;
  border: 1.5px solid #cbd5e1;
  background: white;
  font-size: 0.8rem;
  font-weight: 600;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s;
}
.ctx-close-btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}

.details-card {
  border-radius: 8px !important;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.2s ease;
}
.slide-fade-enter-from {
  transform: translateY(-10px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* History trigger button styles removed — now using Vuetify v-btn tonal */

/* ── Run History dialog ── */
.history-dialog {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 2px 12px rgba(0, 0, 0, 0.06);
}
.history-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 16px;
  background: linear-gradient(135deg, #667eea 0%, #5c6bc0 50%, #7c4dff 100%);
  color: white;
}
.history-dialog-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.history-dialog-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  backdrop-filter: blur(4px);
}
.history-dialog-title {
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.01em;
}
.history-dialog-subtitle {
  font-size: 0.76rem;
  opacity: 0.78;
  margin-top: 1px;
  font-weight: 400;
}
.history-dialog-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  cursor: pointer;
  transition: background 0.15s;
}
.history-dialog-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ── Dialog body / run cards ── */
.history-dialog-body {
  padding: 16px 20px 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 400px;
  overflow-y: auto;
}
.history-run-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid #eaeef5;
  background: #fbfcfe;
  transition: all 0.2s ease;
  animation: historyCardIn 0.35s ease both;
}
.history-run-card:hover {
  border-color: #c5cef5;
  background: #f4f6ff;
  box-shadow: 0 3px 12px rgba(102, 126, 234, 0.08);
}

@keyframes historyCardIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.history-run-card-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.history-run-number {
  font-size: 0.7rem;
  font-weight: 700;
  color: #6366f1;
  background: #eef2ff;
  padding: 1px 7px;
  border-radius: 4px;
  width: fit-content;
}
.history-run-type {
  display: flex;
  align-items: center;
  font-size: 0.88rem;
  font-weight: 650;
  color: #2d3553;
}
.history-run-meta {
  display: flex;
  align-items: center;
  gap: 12px;
}
.history-run-date {
  display: inline-flex;
  align-items: center;
  font-size: 0.75rem;
  color: #8891a5;
}
.history-run-status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.history-run-status--active {
  background: #e8f9ee;
  color: #1b873f;
}
.history-run-status--active .history-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2da44e;
}
.history-run-status--inactive {
  background: #f0f1f4;
  color: #7a7f8d;
}
.history-run-status--inactive .history-status-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a0a4af;
}

/* ── View button inside card ── */
.history-run-view-btn {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1.5px solid #d0d7e3;
  background: white;
  font-size: 0.78rem;
  font-weight: 600;
  color: #5c6bc0;
  cursor: pointer;
  transition: all 0.18s ease;
  white-space: nowrap;
  flex-shrink: 0;
}
.history-run-view-btn:hover {
  background: linear-gradient(135deg, #667eea 0%, #5c6bc0 100%);
  border-color: transparent;
  color: white;
  box-shadow: 0 3px 10px rgba(102, 126, 234, 0.3);
  transform: translateY(-1px);
}
/* Main tabs */
.ctx-main-tabs { margin-bottom: 0; }
.ctx-main-tabs .v-tab { text-transform: none; font-size: 13px; font-weight: 600; letter-spacing: 0; color: #475569 !important; opacity: 1 !important; }
.ctx-main-tabs .v-tab--selected { color: #1976d2 !important; }
.ctx-tab-count {
  display: inline-flex; min-width: 18px; height: 18px; padding: 0 5px;
  border-radius: 9px; background: #e2e8f0; color: #475569;
  font-size: 11px; font-weight: 700; align-items: center; justify-content: center; margin-left: 6px;
}
.ctx-tab-content { padding: 12px 0; }

/* Metric accordion cards */
.ctx-metric-card {
  border: 1px solid #e5e7eb; border-radius: 8px;
  margin-bottom: 8px; overflow: hidden; background: #fff;
}
.ctx-metric-header {
  display: flex; align-items: center; justify-content: space-between;
  padding: 10px 14px; cursor: pointer; user-select: none;
  transition: background 0.15s;
}
.ctx-metric-header:hover { background: #f8fafc; }
.ctx-metric-header-left { display: flex; align-items: center; }
.ctx-metric-header-right { display: flex; gap: 6px; }
.ctx-metric-label { font-size: 13px; font-weight: 600; color: #334155; }
.ctx-metric-body { padding: 0 14px 14px; border-top: 1px solid #f1f5f9; }
.ctx-metric-block { margin-top: 12px; }
.ctx-metric-block-header {
  display: flex; align-items: center; gap: 4px;
  font-size: 11.5px; font-weight: 600; color: #64748b;
  text-transform: uppercase; letter-spacing: 0.3px; margin-bottom: 6px;
}
.ctx-metric-block-header .ctx-copy-btn { margin-left: auto; }
.ctx-ragas-pre {
  background: #f5f7fa; border: 1px solid #e0e4ea; border-radius: 6px;
  padding: 12px; font-size: 11.5px; line-height: 1.5; color: #1e293b;
  max-height: 350px; overflow: auto; white-space: pre-wrap; word-break: break-word;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-x: auto;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead) {
  position: sticky;
  top: 0;
  z-index: 2;
}

.modern-table :deep(.v-table__wrapper thead th) {
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
  height: 8px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
